export const firstPage = `
<html lang="en-US" style="cursor: pointer" id="top">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta
      name="robots"
      content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
    />

    <!-- This site is optimized with the Yoast SEO plugin v19.9 - https://yoast.com/wordpress/plugins/seo/ -->
    <title>
      Vivian Tan Table Tennis Academy | TT Coaching |Holiday Camps Sydney
    </title>
    <meta
      name="description"
      content="Get professional Table Tennis Training at Vivian Tan Table Tennis Training. We also conduct school holiday camps, corporate events &amp; more. Visit us"
    />
    <link rel="canonical" href="https://viviantabletennis.com/" />
    <meta property="og:locale" content="en_US" />
    <meta property="og:type" content="website" />
    <meta
      property="og:title"
      content="Vivian Tan Table Tennis Academy | TT Coaching |Holiday Camps Sydney"
    />
    <meta
      property="og:description"
      content="Get professional Table Tennis Training at Vivian Tan Table Tennis Training. We also conduct school holiday camps, corporate events &amp; more. Visit us"
    />
    <meta property="og:url" content="https://viviantabletennis.com/" />
    <meta property="og:site_name" content="Vivian table tennis" />
    <meta
      property="article:modified_time"
      content="2022-06-07T11:24:50+00:00"
    />
    <meta
      property="og:image"
      content="https://viviantabletennis.com/wp-content/uploads/2022/03/kids-coaches-jumping-1024x683.jpg"
    />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:label1" content="Est. reading time" />
    <meta name="twitter:data1" content="4 minutes" />
    <script
      type="text/javascript"
      async=""
      src="https://www.google-analytics.com/plugins/ua/linkid.js"
    ></script>
    <script
      src="https://connect.facebook.net/signals/config/1000529540890267?v=2.9.89&amp;r=stable"
      async=""
    ></script>
    <script
      src="https://connect.facebook.net/signals/plugins/identity.js?v=2.9.89"
      async=""
    ></script>
    <script
      async=""
      src="https://connect.facebook.net/en_US/fbevents.js"
    ></script>
    <script
      type="text/javascript"
      async=""
      src="https://www.google-analytics.com/analytics.js"
    ></script>
    <script type="application/ld+json" class="yoast-schema-graph">
      {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "WebPage",
            "@id": "https://viviantabletennis.com/",
            "url": "https://viviantabletennis.com/",
            "name": "Vivian Tan Table Tennis Academy | TT Coaching |Holiday Camps Sydney",
            "isPartOf": {
              "@id": "https://viviantabletennis.com/#website"
            },
            "about": {
              "@id": "https://viviantabletennis.com/#organization"
            },
            "primaryImageOfPage": {
              "@id": "https://viviantabletennis.com/#primaryimage"
            },
            "image": {
              "@id": "https://viviantabletennis.com/#primaryimage"
            },
            "thumbnailUrl": "https://viviantabletennis.com/wp-content/uploads/2022/03/kids-coaches-jumping-1024x683.jpg",
            "datePublished": "2019-11-18T07:56:53+00:00",
            "dateModified": "2022-06-07T11:24:50+00:00",
            "description": "Get professional Table Tennis Training at Vivian Tan Table Tennis Training. We also conduct school holiday camps, corporate events & more. Visit us",
            "breadcrumb": {
              "@id": "https://viviantabletennis.com/#breadcrumb"
            },
            "inLanguage": "en-US",
            "potentialAction": [
              {
                "@type": "ReadAction",
                "target": ["https://viviantabletennis.com/"]
              }
            ]
          },
          {
            "@type": "ImageObject",
            "inLanguage": "en-US",
            "@id": "https://viviantabletennis.com/#primaryimage",
            "url": "https://viviantabletennis.com/wp-content/uploads/2022/03/kids-coaches-jumping.jpg",
            "contentUrl": "https://viviantabletennis.com/wp-content/uploads/2022/03/kids-coaches-jumping.jpg",
            "width": 1500,
            "height": 1000
          },
          {
            "@type": "BreadcrumbList",
            "@id": "https://viviantabletennis.com/#breadcrumb",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Home" }
            ]
          },
          {
            "@type": "WebSite",
            "@id": "https://viviantabletennis.com/#website",
            "url": "https://viviantabletennis.com/",
            "name": "Vivian table tennis",
            "description": "Raising up tomorrow&#039;s young champions",
            "publisher": {
              "@id": "https://viviantabletennis.com/#organization"
            },
            "potentialAction": [
              {
                "@type": "SearchAction",
                "target": {
                  "@type": "EntryPoint",
                  "urlTemplate": "https://viviantabletennis.com/?s={search_term_string}"
                },
                "query-input": "required name=search_term_string"
              }
            ],
            "inLanguage": "en-US"
          },
          {
            "@type": "Organization",
            "@id": "https://viviantabletennis.com/#organization",
            "name": "Vivian table tennis",
            "url": "https://viviantabletennis.com/",
            "logo": {
              "@type": "ImageObject",
              "inLanguage": "en-US",
              "@id": "https://viviantabletennis.com/#/schema/logo/image/",
              "url": "https://viviantabletennis.com/wp-content/uploads/2022/03/Vivian-Tan-Logo-white.png",
              "contentUrl": "https://viviantabletennis.com/wp-content/uploads/2022/03/Vivian-Tan-Logo-white.png",
              "width": 828,
              "height": 351,
              "caption": "Vivian table tennis"
            },
            "image": {
              "@id": "https://viviantabletennis.com/#/schema/logo/image/"
            }
          }
        ]
      }
    </script>

    <meta
      name="google-site-verification"
      content="-JzHe3nAfB--KNc2YUFs_2E4kzMHMwPwtHBqlMX0bu0"
    />
    <!-- / Yoast SEO plugin. -->

    <link rel="dns-prefetch" href="//fonts.googleapis.com" />
    <link rel="dns-prefetch" href="//s.w.org" />
    <link
      rel="alternate"
      type="application/rss+xml"
      title="Vivian table tennis » Feed"
      href="https://viviantabletennis.com/feed/"
    />
    <link
      rel="alternate"
      type="application/rss+xml"
      title="Vivian table tennis » Comments Feed"
      href="https://viviantabletennis.com/comments/feed/"
    />
    <!-- This site uses the Google Analytics by MonsterInsights plugin v8.9.1 - Using Analytics tracking - https://www.monsterinsights.com/ -->
    <script
      src="//www.googletagmanager.com/gtag/js?id=UA-224017852-1"
      data-cfasync="false"
      data-wpfc-render="false"
      type="text/javascript"
      async=""
    ></script>
    <script
      data-cfasync="false"
      data-wpfc-render="false"
      type="text/javascript"
    >
      var mi_version = "8.9.1";
      var mi_track_user = true;
      var mi_no_track_reason = "";

      var disableStrs = ["ga-disable-UA-224017852-1"];

      /* Function to detect opted out users */
      function __gtagTrackerIsOptedOut() {
        for (var index = 0; index < disableStrs.length; index++) {
          if (document.cookie.indexOf(disableStrs[index] + "=true") > -1) {
            return true;
          }
        }

        return false;
      }

      /* Disable tracking if the opt-out cookie exists. */
      if (__gtagTrackerIsOptedOut()) {
        for (var index = 0; index < disableStrs.length; index++) {
          window[disableStrs[index]] = true;
        }
      }

      /* Opt-out function */
      function __gtagTrackerOptout() {
        for (var index = 0; index < disableStrs.length; index++) {
          document.cookie =
            disableStrs[index] +
            "=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/";
          window[disableStrs[index]] = true;
        }
      }

      if ("undefined" === typeof gaOptout) {
        function gaOptout() {
          __gtagTrackerOptout();
        }
      }
      window.dataLayer = window.dataLayer || [];

      window.MonsterInsightsDualTracker = {
        helpers: {},
        trackers: {},
      };
      if (mi_track_user) {
        function __gtagDataLayer() {
          dataLayer.push(arguments);
        }

        function __gtagTracker(type, name, parameters) {
          if (!parameters) {
            parameters = {};
          }

          if (parameters.send_to) {
            __gtagDataLayer.apply(null, arguments);
            return;
          }

          if (type === "event") {
            parameters.send_to = monsterinsights_frontend.ua;
            __gtagDataLayer(type, name, parameters);
          } else {
            __gtagDataLayer.apply(null, arguments);
          }
        }

        __gtagTracker("js", new Date());
        __gtagTracker("set", {
          "developer_id.dZGIzZG": true,
        });
        __gtagTracker("config", "UA-224017852-1", {
          forceSSL: "true",
          link_attribution: "true",
        });
        window.gtag = __gtagTracker;
        (function () {
          /* https://developers.google.com/analytics/devguides/collection/analyticsjs/ */
          /* ga and __gaTracker compatibility shim. */
          var noopfn = function () {
            return null;
          };
          var newtracker = function () {
            return new Tracker();
          };
          var Tracker = function () {
            return null;
          };
          var p = Tracker.prototype;
          p.get = noopfn;
          p.set = noopfn;
          p.send = function () {
            var args = Array.prototype.slice.call(arguments);
            args.unshift("send");
            __gaTracker.apply(null, args);
          };
          var __gaTracker = function () {
            var len = arguments.length;
            if (len === 0) {
              return;
            }
            var f = arguments[len - 1];
            if (
              typeof f !== "object" ||
              f === null ||
              typeof f.hitCallback !== "function"
            ) {
              if ("send" === arguments[0]) {
                var hitConverted,
                  hitObject = false,
                  action;
                if ("event" === arguments[1]) {
                  if ("undefined" !== typeof arguments[3]) {
                    hitObject = {
                      eventAction: arguments[3],
                      eventCategory: arguments[2],
                      eventLabel: arguments[4],
                      value: arguments[5] ? arguments[5] : 1,
                    };
                  }
                }
                if ("pageview" === arguments[1]) {
                  if ("undefined" !== typeof arguments[2]) {
                    hitObject = {
                      eventAction: "page_view",
                      page_path: arguments[2],
                    };
                  }
                }
                if (typeof arguments[2] === "object") {
                  hitObject = arguments[2];
                }
                if (typeof arguments[5] === "object") {
                  Object.assign(hitObject, arguments[5]);
                }
                if ("undefined" !== typeof arguments[1].hitType) {
                  hitObject = arguments[1];
                  if ("pageview" === hitObject.hitType) {
                    hitObject.eventAction = "page_view";
                  }
                }
                if (hitObject) {
                  action =
                    "timing" === arguments[1].hitType
                      ? "timing_complete"
                      : hitObject.eventAction;
                  hitConverted = mapArgs(hitObject);
                  __gtagTracker("event", action, hitConverted);
                }
              }
              return;
            }

            function mapArgs(args) {
              var arg,
                hit = {};
              var gaMap = {
                eventCategory: "event_category",
                eventAction: "event_action",
                eventLabel: "event_label",
                eventValue: "event_value",
                nonInteraction: "non_interaction",
                timingCategory: "event_category",
                timingVar: "name",
                timingValue: "value",
                timingLabel: "event_label",
                page: "page_path",
                location: "page_location",
                title: "page_title",
              };
              for (arg in args) {
                if (
                  !(!args.hasOwnProperty(arg) || !gaMap.hasOwnProperty(arg))
                ) {
                  hit[gaMap[arg]] = args[arg];
                } else {
                  hit[arg] = args[arg];
                }
              }
              return hit;
            }

            try {
              f.hitCallback();
            } catch (ex) {}
          };
          __gaTracker.create = newtracker;
          __gaTracker.getByName = newtracker;
          __gaTracker.getAll = function () {
            return [];
          };
          __gaTracker.remove = noopfn;
          __gaTracker.loaded = true;
          window["__gaTracker"] = __gaTracker;
        })();
      } else {
        console.log("");
        (function () {
          function __gtagTracker() {
            return null;
          }

          window["__gtagTracker"] = __gtagTracker;
          window["gtag"] = __gtagTracker;
        })();
      }
    </script>
    <!-- / Google Analytics by MonsterInsights -->
    <script type="text/javascript">
      window._wpemojiSettings = {
        baseUrl: "https:\/\/s.w.org\/images\/core\/emoji\/14.0.0\/72x72\/",
        ext: ".png",
        svgUrl: "https:\/\/s.w.org\/images\/core\/emoji\/14.0.0\/svg\/",
        svgExt: ".svg",
        source: {
          concatemoji:
            "https:\/\/www.viviantabletennis.com.au\/wp-includes\/js\/wp-emoji-release.min.js?ver=6.0.3",
        },
      };
      /*! This file is auto-generated */
      !(function (e, a, t) {
        var n,
          r,
          o,
          i = a.createElement("canvas"),
          p = i.getContext && i.getContext("2d");
        function s(e, t) {
          var a = String.fromCharCode,
            e =
              (p.clearRect(0, 0, i.width, i.height),
              p.fillText(a.apply(this, e), 0, 0),
              i.toDataURL());
          return (
            p.clearRect(0, 0, i.width, i.height),
            p.fillText(a.apply(this, t), 0, 0),
            e === i.toDataURL()
          );
        }
        function c(e) {
          var t = a.createElement("script");
          (t.src = e),
            (t.defer = t.type = "text/javascript"),
            a.getElementsByTagName("head")[0].appendChild(t);
        }
        for (
          o = Array("flag", "emoji"),
            t.supports = { everything: !0, everythingExceptFlag: !0 },
            r = 0;
          r < o.length;
          r++
        )
          (t.supports[o[r]] = (function (e) {
            if (!p || !p.fillText) return !1;
            switch (
              ((p.textBaseline = "top"), (p.font = "600 32px Arial"), e)
            ) {
              case "flag":
                return s(
                  [127987, 65039, 8205, 9895, 65039],
                  [127987, 65039, 8203, 9895, 65039]
                )
                  ? !1
                  : !s(
                      [55356, 56826, 55356, 56819],
                      [55356, 56826, 8203, 55356, 56819]
                    ) &&
                      !s(
                        [
                          55356, 57332, 56128, 56423, 56128, 56418, 56128,
                          56421, 56128, 56430, 56128, 56423, 56128, 56447,
                        ],
                        [
                          55356, 57332, 8203, 56128, 56423, 8203, 56128, 56418,
                          8203, 56128, 56421, 8203, 56128, 56430, 8203, 56128,
                          56423, 8203, 56128, 56447,
                        ]
                      );
              case "emoji":
                return !s(
                  [129777, 127995, 8205, 129778, 127999],
                  [129777, 127995, 8203, 129778, 127999]
                );
            }
            return !1;
          })(o[r])),
            (t.supports.everything = t.supports.everything && t.supports[o[r]]),
            "flag" !== o[r] &&
              (t.supports.everythingExceptFlag =
                t.supports.everythingExceptFlag && t.supports[o[r]]);
        (t.supports.everythingExceptFlag =
          t.supports.everythingExceptFlag && !t.supports.flag),
          (t.DOMReady = !1),
          (t.readyCallback = function () {
            t.DOMReady = !0;
          }),
          t.supports.everything ||
            ((n = function () {
              t.readyCallback();
            }),
            a.addEventListener
              ? (a.addEventListener("DOMContentLoaded", n, !1),
                e.addEventListener("load", n, !1))
              : (e.attachEvent("onload", n),
                a.attachEvent("onreadystatechange", function () {
                  "complete" === a.readyState && t.readyCallback();
                })),
            (e = t.source || {}).concatemoji
              ? c(e.concatemoji)
              : e.wpemoji && e.twemoji && (c(e.twemoji), c(e.wpemoji)));
      })(window, document, window._wpemojiSettings);
    </script>
    <script
      src="https://viviantabletennis.com/wp-includes/js/wp-emoji-release.min.js?ver=6.0.3"
      type="text/javascript"
      defer=""
    ></script>
    <link
      rel="stylesheet"
      type="text/css"
      href="https://use.typekit.net/ppn2ofs.css"
    />
    <style type="text/css">
      img.wp-smiley,
      img.emoji {
        display: inline !important;
        border: none !important;
        box-shadow: none !important;
        height: 1em !important;
        width: 1em !important;
        margin: 0 0.07em !important;
        vertical-align: -0.1em !important;
        background: none !important;
        padding: 0 !important;
      }
    </style>
    <link
      rel="stylesheet"
      id="wp-block-library-css"
      href="https://viviantabletennis.com/wp-includes/css/dist/block-library/style.min.css?ver=6.0.3"
      type="text/css"
      media="all"
    />
    <style id="global-styles-inline-css" type="text/css">
      body {
        --wp--preset--color--black: #000000;
        --wp--preset--color--cyan-bluish-gray: #abb8c3;
        --wp--preset--color--white: #ffffff;
        --wp--preset--color--pale-pink: #f78da7;
        --wp--preset--color--vivid-red: #cf2e2e;
        --wp--preset--color--luminous-vivid-orange: #ff6900;
        --wp--preset--color--luminous-vivid-amber: #fcb900;
        --wp--preset--color--light-green-cyan: #7bdcb5;
        --wp--preset--color--vivid-green-cyan: #00d084;
        --wp--preset--color--pale-cyan-blue: #8ed1fc;
        --wp--preset--color--vivid-cyan-blue: #0693e3;
        --wp--preset--color--vivid-purple: #9b51e0;
        --wp--preset--gradient--vivid-cyan-blue-to-vivid-purple: linear-gradient(
          135deg,
          rgba(6, 147, 227, 1) 0%,
          rgb(155, 81, 224) 100%
        );
        --wp--preset--gradient--light-green-cyan-to-vivid-green-cyan: linear-gradient(
          135deg,
          rgb(122, 220, 180) 0%,
          rgb(0, 208, 130) 100%
        );
        --wp--preset--gradient--luminous-vivid-amber-to-luminous-vivid-orange: linear-gradient(
          135deg,
          rgba(252, 185, 0, 1) 0%,
          rgba(255, 105, 0, 1) 100%
        );
        --wp--preset--gradient--luminous-vivid-orange-to-vivid-red: linear-gradient(
          135deg,
          rgba(255, 105, 0, 1) 0%,
          rgb(207, 46, 46) 100%
        );
        --wp--preset--gradient--very-light-gray-to-cyan-bluish-gray: linear-gradient(
          135deg,
          rgb(238, 238, 238) 0%,
          rgb(169, 184, 195) 100%
        );
        --wp--preset--gradient--cool-to-warm-spectrum: linear-gradient(
          135deg,
          rgb(74, 234, 220) 0%,
          rgb(151, 120, 209) 20%,
          rgb(207, 42, 186) 40%,
          rgb(238, 44, 130) 60%,
          rgb(251, 105, 98) 80%,
          rgb(254, 248, 76) 100%
        );
        --wp--preset--gradient--blush-light-purple: linear-gradient(
          135deg,
          rgb(255, 206, 236) 0%,
          rgb(152, 150, 240) 100%
        );
        --wp--preset--gradient--blush-bordeaux: linear-gradient(
          135deg,
          rgb(254, 205, 165) 0%,
          rgb(254, 45, 45) 50%,
          rgb(107, 0, 62) 100%
        );
        --wp--preset--gradient--luminous-dusk: linear-gradient(
          135deg,
          rgb(255, 203, 112) 0%,
          rgb(199, 81, 192) 50%,
          rgb(65, 88, 208) 100%
        );
        --wp--preset--gradient--pale-ocean: linear-gradient(
          135deg,
          rgb(255, 245, 203) 0%,
          rgb(182, 227, 212) 50%,
          rgb(51, 167, 181) 100%
        );
        --wp--preset--gradient--electric-grass: linear-gradient(
          135deg,
          rgb(202, 248, 128) 0%,
          rgb(113, 206, 126) 100%
        );
        --wp--preset--gradient--midnight: linear-gradient(
          135deg,
          rgb(2, 3, 129) 0%,
          rgb(40, 116, 252) 100%
        );
        --wp--preset--duotone--dark-grayscale: url("#wp-duotone-dark-grayscale");
        --wp--preset--duotone--grayscale: url("#wp-duotone-grayscale");
        --wp--preset--duotone--purple-yellow: url("#wp-duotone-purple-yellow");
        --wp--preset--duotone--blue-red: url("#wp-duotone-blue-red");
        --wp--preset--duotone--midnight: url("#wp-duotone-midnight");
        --wp--preset--duotone--magenta-yellow: url("#wp-duotone-magenta-yellow");
        --wp--preset--duotone--purple-green: url("#wp-duotone-purple-green");
        --wp--preset--duotone--blue-orange: url("#wp-duotone-blue-orange");
        --wp--preset--font-size--small: 13px;
        --wp--preset--font-size--medium: 20px;
        --wp--preset--font-size--large: 36px;
        --wp--preset--font-size--x-large: 42px;
      }
      .has-black-color {
        color: var(--wp--preset--color--black) !important;
      }
      .has-cyan-bluish-gray-color {
        color: var(--wp--preset--color--cyan-bluish-gray) !important;
      }
      .has-white-color {
        color: var(--wp--preset--color--white) !important;
      }
      .has-pale-pink-color {
        color: var(--wp--preset--color--pale-pink) !important;
      }
      .has-vivid-red-color {
        color: var(--wp--preset--color--vivid-red) !important;
      }
      .has-luminous-vivid-orange-color {
        color: var(--wp--preset--color--luminous-vivid-orange) !important;
      }
      .has-luminous-vivid-amber-color {
        color: var(--wp--preset--color--luminous-vivid-amber) !important;
      }
      .has-light-green-cyan-color {
        color: var(--wp--preset--color--light-green-cyan) !important;
      }
      .has-vivid-green-cyan-color {
        color: var(--wp--preset--color--vivid-green-cyan) !important;
      }
      .has-pale-cyan-blue-color {
        color: var(--wp--preset--color--pale-cyan-blue) !important;
      }
      .has-vivid-cyan-blue-color {
        color: var(--wp--preset--color--vivid-cyan-blue) !important;
      }
      .has-vivid-purple-color {
        color: var(--wp--preset--color--vivid-purple) !important;
      }
      .has-black-background-color {
        background-color: var(--wp--preset--color--black) !important;
      }
      .has-cyan-bluish-gray-background-color {
        background-color: var(--wp--preset--color--cyan-bluish-gray) !important;
      }
      .has-white-background-color {
        background-color: var(--wp--preset--color--white) !important;
      }
      .has-pale-pink-background-color {
        background-color: var(--wp--preset--color--pale-pink) !important;
      }
      .has-vivid-red-background-color {
        background-color: var(--wp--preset--color--vivid-red) !important;
      }
      .has-luminous-vivid-orange-background-color {
        background-color: var(
          --wp--preset--color--luminous-vivid-orange
        ) !important;
      }
      .has-luminous-vivid-amber-background-color {
        background-color: var(
          --wp--preset--color--luminous-vivid-amber
        ) !important;
      }
      .has-light-green-cyan-background-color {
        background-color: var(--wp--preset--color--light-green-cyan) !important;
      }
      .has-vivid-green-cyan-background-color {
        background-color: var(--wp--preset--color--vivid-green-cyan) !important;
      }
      .has-pale-cyan-blue-background-color {
        background-color: var(--wp--preset--color--pale-cyan-blue) !important;
      }
      .has-vivid-cyan-blue-background-color {
        background-color: var(--wp--preset--color--vivid-cyan-blue) !important;
      }
      .has-vivid-purple-background-color {
        background-color: var(--wp--preset--color--vivid-purple) !important;
      }
      .has-black-border-color {
        border-color: var(--wp--preset--color--black) !important;
      }
      .has-cyan-bluish-gray-border-color {
        border-color: var(--wp--preset--color--cyan-bluish-gray) !important;
      }
      .has-white-border-color {
        border-color: var(--wp--preset--color--white) !important;
      }
      .has-pale-pink-border-color {
        border-color: var(--wp--preset--color--pale-pink) !important;
      }
      .has-vivid-red-border-color {
        border-color: var(--wp--preset--color--vivid-red) !important;
      }
      .has-luminous-vivid-orange-border-color {
        border-color: var(
          --wp--preset--color--luminous-vivid-orange
        ) !important;
      }
      .has-luminous-vivid-amber-border-color {
        border-color: var(--wp--preset--color--luminous-vivid-amber) !important;
      }
      .has-light-green-cyan-border-color {
        border-color: var(--wp--preset--color--light-green-cyan) !important;
      }
      .has-vivid-green-cyan-border-color {
        border-color: var(--wp--preset--color--vivid-green-cyan) !important;
      }
      .has-pale-cyan-blue-border-color {
        border-color: var(--wp--preset--color--pale-cyan-blue) !important;
      }
      .has-vivid-cyan-blue-border-color {
        border-color: var(--wp--preset--color--vivid-cyan-blue) !important;
      }
      .has-vivid-purple-border-color {
        border-color: var(--wp--preset--color--vivid-purple) !important;
      }
      .has-vivid-cyan-blue-to-vivid-purple-gradient-background {
        background: var(
          --wp--preset--gradient--vivid-cyan-blue-to-vivid-purple
        ) !important;
      }
      .has-light-green-cyan-to-vivid-green-cyan-gradient-background {
        background: var(
          --wp--preset--gradient--light-green-cyan-to-vivid-green-cyan
        ) !important;
      }
      .has-luminous-vivid-amber-to-luminous-vivid-orange-gradient-background {
        background: var(
          --wp--preset--gradient--luminous-vivid-amber-to-luminous-vivid-orange
        ) !important;
      }
      .has-luminous-vivid-orange-to-vivid-red-gradient-background {
        background: var(
          --wp--preset--gradient--luminous-vivid-orange-to-vivid-red
        ) !important;
      }
      .has-very-light-gray-to-cyan-bluish-gray-gradient-background {
        background: var(
          --wp--preset--gradient--very-light-gray-to-cyan-bluish-gray
        ) !important;
      }
      .has-cool-to-warm-spectrum-gradient-background {
        background: var(
          --wp--preset--gradient--cool-to-warm-spectrum
        ) !important;
      }
      .has-blush-light-purple-gradient-background {
        background: var(--wp--preset--gradient--blush-light-purple) !important;
      }
      .has-blush-bordeaux-gradient-background {
        background: var(--wp--preset--gradient--blush-bordeaux) !important;
      }
      .has-luminous-dusk-gradient-background {
        background: var(--wp--preset--gradient--luminous-dusk) !important;
      }
      .has-pale-ocean-gradient-background {
        background: var(--wp--preset--gradient--pale-ocean) !important;
      }
      .has-electric-grass-gradient-background {
        background: var(--wp--preset--gradient--electric-grass) !important;
      }
      .has-midnight-gradient-background {
        background: var(--wp--preset--gradient--midnight) !important;
      }
      .has-small-font-size {
        font-size: var(--wp--preset--font-size--small) !important;
      }
      .has-medium-font-size {
        font-size: var(--wp--preset--font-size--medium) !important;
      }
      .has-large-font-size {
        font-size: var(--wp--preset--font-size--large) !important;
      }
      .has-x-large-font-size {
        font-size: var(--wp--preset--font-size--x-large) !important;
      }
    </style>
 
    <style id="business-pro-theme-inline-css" type="text/css">
      button.accent,
      .button.accent,
      button.accent:hover,
      .button.accent:hover,
      button.accent:focus,
      .button.accent:focus,
      .menu-item.button > a > span,
      .archive-pagination a:hover,
      .archive-pagination a:focus,
      .archive-pagination .active a,
      .pricing-table .featured .button,
      .pricing-table .featured button,
      .archive-pagination a:hover,
      .archive-pagination .active a,
      .front-page-3 .widget_custom_html:first-of-type hr,
      .front-page-5 .widget_custom_html:first-of-type hr {
        background-color: #d24d36;
      }
      .front-page-2 .fa {
        color: #d24d36;
      }
      .wp-custom-logo .title-area {
        max-width: 150px;
      }
    </style>
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-content/plugins/google-analytics-for-wordpress/assets/js/frontend-gtag.min.js?ver=8.9.1"
      id="monsterinsights-frontend-script-js"
    ></script>
    <script
      data-cfasync="false"
      data-wpfc-render="false"
      type="text/javascript"
      id="monsterinsights-frontend-script-js-extra"
    >
      /* <![CDATA[ */
      var monsterinsights_frontend = {
        js_events_tracking: "true",
        download_extensions: "doc,pdf,ppt,zip,xls,docx,pptx,xlsx",
        inbound_paths:
          '[{"path":"\\\/go\\\/","label":"affiliate"},{"path":"\\\/recommend\\\/","label":"affiliate"}]',
        home_url: "https:\/\/www.viviantabletennis.com.au",
        hash_tracking: "false",
        ua: "UA-224017852-1",
        v4_id: "",
      }; /* ]]> */
    </script>
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-includes/js/jquery/jquery.min.js?ver=3.6.0"
      id="jquery-core-js"
    ></script>
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-includes/js/jquery/jquery-migrate.min.js?ver=3.3.2"
      id="jquery-migrate-js"
    ></script>
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-content/plugins/elementor/assets/lib/font-awesome/js/v4-shims.min.js?ver=3.8.0"
      id="font-awesome-4-shim-js"
    ></script>
    <link rel="https://api.w.org/" href="https://viviantabletennis.com/wp-json/" />
    <link
      rel="alternate"
      type="application/json"
      href="https://viviantabletennis.com/wp-json/wp/v2/pages/42"
    />
    <link
      rel="EditURI"
      type="application/rsd+xml"
      title="RSD"
      href="https://viviantabletennis.com/xmlrpc.php?rsd"
    />
    <link
      rel="wlwmanifest"
      type="application/wlwmanifest+xml"
      href="https://viviantabletennis.com/wp-includes/wlwmanifest.xml"
    />
    <meta name="generator" content="WordPress 6.0.3" />
    <link rel="shortlink" href="https://viviantabletennis.com/" />
    <link
      rel="alternate"
      type="application/json+oembed"
      href="https://viviantabletennis.com/wp-json/oembed/1.0/embed?url=https%3A%2F%2Fwww.viviantabletennis.com.au%2F"
    />
    <link
      rel="alternate"
      type="text/xml+oembed"
      href="https://viviantabletennis.com/wp-json/oembed/1.0/embed?url=https%3A%2F%2Fwww.viviantabletennis.com.au%2F&amp;format=xml"
    />
    <meta name="format-detection" content="telephone=no" />

    <script>
      jQuery(document).ready(function ($) {
        document.addEventListener("touchstart", function () {}, true);
      });
    </script>
    <link
      rel="stylesheet"
      href="https://viviantabletennis.com/wp-content/custom-global-styles/plan-section-styles.css"
    />
    <link
      rel="stylesheet"
      href="https://viviantabletennis.com/wp-content/custom-global-styles/lead-generator-section-styles.css"
    />
    <link
      rel="stylesheet"
      href="https://viviantabletennis.com/wp-content/custom-global-styles/template-sections.css"
    />
    <link
      rel="stylesheet"
      href="https://viviantabletennis.com/wp-content/custom-global-styles/testimonial-section.css"
    />
    <link
      rel="stylesheet"
      href="https://viviantabletennis.com/wp-content/custom-global-styles/case-study-styles.css"
    />
    <link
      rel="stylesheet"
      href="https://viviantabletennis.com/wp-content/custom-global-styles/service-boxes.css"
    />
    <link
      rel="stylesheet"
      href="https://viviantabletennis.com/wp-content/custom-global-styles/instagram-feed.css"
    />
    <!-- Meta Pixel Code -->
    <script type="text/javascript">
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(
        window,
        document,
        "script",
        "https://connect.facebook.net/en_US/fbevents.js"
      );
    </script>
    <!-- End Meta Pixel Code -->
    <script type="text/javascript">
      fbq(
        "init",
        "1000529540890267",
        {},
        {
          agent: "wordpress-6.0.3-3.0.7",
        }
      );
    </script>
    <script type="text/javascript">
      fbq("track", "PageView", []);
    </script>
    <!-- Meta Pixel Code -->
    <noscript>
      <img
        height="1"
        width="1"
        style="display: none"
        alt="fbpx"
        src="https://www.facebook.com/tr?id=1000529540890267&ev=PageView&noscript=1"
      />
    </noscript>
    <!-- End Meta Pixel Code -->
    <style type="text/css">
      .recentcomments a {
        display: inline !important;
        padding: 0 !important;
        margin: 0 !important;
      }
    </style>
    <link
      rel="icon"
      href="https://viviantabletennis.com/wp-content/uploads/2022/05/cropped-v-favicon-32x32.png"
      sizes="32x32"
    />
    <link
      rel="icon"
      href="https://viviantabletennis.com/wp-content/uploads/2022/05/cropped-v-favicon-192x192.png"
      sizes="192x192"
    />
    <link
      rel="apple-touch-icon"
      href="https://viviantabletennis.com/wp-content/uploads/2022/05/cropped-v-favicon-180x180.png"
    />
    <meta
      name="msapplication-TileImage"
      content="https://viviantabletennis.com/wp-content/uploads/2022/05/cropped-v-favicon-270x270.png"
    />
    <style type="text/css" id="wp-custom-css">
      /*----------------------------Global Styles----------------------------*/
      .hero-section h1 {
        max-width: 662px;
        margin: 0 auto 0.382em;
      }
      /*------EFFECTS, ANIMATIONS & BLANKET STYLES------*/
      :active,
      :focus {
        outline: none !important;
      }

      input,
      textarea,
      button,
      select,
      a,
      #back-to-top {
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      }

      body {
        background-color: #f3f3f3;
      }

      .site-container {
        background-color: #f3f3f3;
      }
      .site-inner {
        background: #f3f3f3;
        margin-bottom: 30rem;
        position: relative;
        z-index: 9;
      }

      p a,
      li a,
      a.tab-btn,
      .elementor-button,
      .nav-primary li a,
      .nav-primary li a:after,
      .site-header > .wrap,
      .title-area,
      .title-area::before,
      .title-area a,
      .title-area a::before,
      .title-area a img,
      .site-header.shrink .title-area a,
      #menu-footer-menu li a,
      #menu-junk-drawer li a,
      a.sbi_photo:before,
      a.sbi_photo:after,
      .social-icon a,
      .top-buttons-right a,
      .elementor-testimonial__cta a,
      .elementor__cta-wire a,
      input.gform_button,
      input[type="button"],
      button[type="submit"],
      .king-designs-logo-wrapper a {
        -webkit-transition: all 0.3s ease-in-out;
        -moz-transition: all 0.3s ease-in-out;
        -o-transition: all 0.3s ease-in-out;
      }

      .wire-button.elementor-widget-button .elementor-button {
        padding: calc(0.9em - 0.2rem) calc(1.6em - 0.2rem);
        background: transparent;
        border: 0.2rem solid #40aad5;
        color: #40aad5;
      }

      .wire-button .elementor-button:hover,
      .wire-button .elementor-button:active,
      .wire-button .elementor-button:focus {
        background: #40aad5;
        color: #f3f3f3;
      }

      a.tab-btn,
      .elementor-widget-button:not(.wire-button) a.elementor-button,
      input[type="button"],
      input[type="submit"],
      button[type="submit"],
      .feature-image img,
      #respond #submit {
        box-shadow: none;
      }

      /* a.tab-btn:hover, a.tab-btn:active, a.tab-btn:focus, .elementor-widget-button:not(.wire-button) .elementor-button:hover, .elementor-widget-button:not(.wire-button) .elementor-button:active, .elementor-widget-button:not(.wire-button) .elementor-button:focus, input[type='button']:hover, input[type='button']:active, input[type='button']:focus, input[type='submit']:hover, input[type='submit']:active, input[type='submit']:focus {
	opacity:1 !important;
  box-shadow:none;
	-ms-transform:translateY(-0.5rem);
  -webkit-transform:translateY(-0.5rem);
  transform:translateY(-0.5rem);
} */

      section#hero .elementor-button {
        padding: 1.5rem 3rem;
        box-shadow: none !important;
      }
      section#hero .elementor-button:hover,
      section#hero .elementor-button:active,
      section#hero .elementor-button:focus {
        box-shadow: none !important;
      }

      /*------GLOBAL ICONS--------*/
      i.fab {
        font-size: 2.4rem;
        font-family: "Font Awesome 5 Brands";
        font-style: normal;
        position: absolute;
      }

      i.eicon-chevron-right::before {
        content: "\f112";
      }

      i.eicon-chevron-left::before {
        content: "\f111";
      }

      i.arrow-right::before {
        content: "\f167";
      }

      .fa-facebook-f::before,
      .fa-facebook::before {
        content: "\f39e";
      }

      .fa-twitter::before {
        content: "\f099";
      }

      .fa-youtube::before {
        content: "\f167";
      }

      .fa-linkedin::before {
        content: "\f0e1";
      }

      .fa-instagram::before {
        content: "\f16d";
      }

      .eicon-play {
        font-family: fontawesome;
      }

      .eicon-play:before {
        content: "\f167";
      }

      /*-------HEADER STYLE-------*/
      .site-header > .wrap {
        width: 90%;
        max-width: 114rem;
        margin-top: 2rem;
        margin-bottom: 2rem;
        padding: 1rem !important;
      }

      .site-header.shrink > .wrap {
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
      }

      .has-fixed-header .site-header.shrink {
        background-color: #030e13;
      }

      .site-header.shrink .title-area a::before {
        content: "";
        background-image: url("https://viviantabletennis.com/wp-content/uploads/2022/03/Vivian-Tan-Logo-red-white.png");
        background-size: contain;
        background-repeat: no-repeat;
        height: 5.5rem;
        width: 13rem;
        position: absolute;
        opacity: 0;
      }

      .site-header.shrink .title-area a::before {
        opacity: 1;
      }

      .site-header.shrink .title-area a img {
        opacity: 0;
      }

      .wp-custom-logo .title-area {
        padding: 0;
        max-width: 13rem;
      }

      .nav-primary li {
        padding: 1.7rem 1.7rem 1.5rem;
        line-height: 0;
      }

      .nav-primary li a {
        padding: 0;
        font-size: 0.95em;
        font-weight: 500;
        line-height: 1em;
      }

      .nav-primary li a:hover,
      .nav-primary li a:active,
      .nav-primary li a:focus {
        color: #40aad5 !important;
      }

      .nav-primary li.main-menu-cta {
        margin-left: 1rem;
        padding: 0;
      }

      .nav-primary li.main-menu-cta a {
        border: #f3f3f3 solid 1px;
        padding: 1.7rem 1.7rem 1.5rem;
        text-align: center;
        text-transform: uppercase;
        font-weight: 600;
        color: #f3f3f3;
      }

      .nav-primary li.main-menu-cta a:hover,
      .nav-primary li.main-menu-cta a:active,
      .nav-primary li.main-menu-cta a:focus {
        color: #f3f3f3 !important;
        background: #40aad5;
        border-color: #40aad5;
      }

      .nav-primary li.menu-item.current_page_item a {
        position: relative;
      }

      .nav-primary li.menu-item.current_page_item:not(.main-menu-cta) a:after {
        content: ;
        display: block;
        width: 100%;
        position: absolute;
        height: 1px;
        background: #f3f3f3;
        margin-top: 0.5rem;
      }

      .nav-primary li.menu-item.current_page_item a:hover:after,
      .nav-primary li.menu-item.current_page_item a:active:after,
      .nav-primary li.menu-item.current_page_item a:focus:after {
        background: #40aad5;
      }

      .nav-primary li.mobile-menu-icon,
      .mobile-social-heading {
        display: none;
      }

      /*------TYPEFACE STYLES------*/
      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      .nav-primary a,
      .elementor-testimonial__name,
      .elementor-testimonial__title,
      .elementor-testimonial__brand-name,
      .elementor-widget-text-editor,
      .elementor-widget-text-editor ul,
      body,
      p,
      a.tab-btn,
      .elementor-button-text,
      .elementor-testimonial__cta a,
      .elementor-widget-post-info .elementor-icon-list-item,
      .elementor-widget-author-box .elementor-author-box__bio,
      .gfield_label,
      .gform_wrapper input[type="text"],
      .gform_wrapper textarea,
      .gform_wrapper input[type="submit"],
      #menu-footer-menu {
        font-family: "proxima-nova", "Ek Mukta", sans-serif !important;
      }

      h3,
      h4,
      h5,
      body,
      p,
      li,
      .elementor-widget-text-editor {
        color: #171717;
      }

      h1 {
        font-size: 5rem;
        font-weight: 800 !important;
        line-height: 1em;
      }

      h2 {
        font-size: 2.4rem;
        line-height: 1.2em !important;
        font-weight: 400 !important;
        max-width: 100rem;
        width: 100%;
      }

      h3 {
        font-size: 3.2rem;
        font-weight: 800 !important;
      }

      h4 {
        font-size: 1.8rem;
        margin-bottom: 1.5rem;
        font-weight: 800 !important;
        max-width: 50rem;
        line-height: 1.2em !important;
      }

      h5,
      h5.elementor-cta__title {
        font-size: 2.6rem;
        margin-bottom: 3rem;
        font-weight: 800 !important;
      }

      h6 {
        font-size: 2.4rem;
        margin-bottom: 1rem;
      }

      .elementor-heading-title {
        margin-left: auto;
        margin-right: auto;
      }

      body,
      p,
      section:not(#hero).elementor-icon-list-text,
      li {
        font-size: 1.8rem;
        line-height: 1.4em;
        font-weight: 300;
      }

      .dark-section h3,
      .dark-section h4,
      .dark-section h5,
      .dark-section p,
      .dark-section li {
        color: #f3f3f3 !important;
      }

      a.tab-btn,
      .elementor-button-text {
        font-weight: 700;
        text-decoration: none;
      }

      p {
        margin-bottom: 1rem;
      }

      p a,
      .site-inner li a {
        font-weight: 600;
        color: #40aad5;
        text-decoration: underline !important;
      }

      p a:hover,
      p a:active,
      p a:focus,
      li a:hover,
      li a:active,
      li a:focus {
        color: #a8a8a8;
      }

      strong {
        font-weight: 700;
      }

      em {
        font-style: italic;
      }

      .elementor-widget-text-editor ul {
        margin-bottom: 1rem;
      }

      .footnote p {
        font-size: 1.1rem;
        width: 90%;
        max-width: 30rem;
        margin: auto;
      }

      .footnote p a {
        color: #171717;
        font-weight: 400;
        text-decoration: underline;
      }

      /*------CHECK LISTS-------*/
      .check-list .elementor-widget-container ul,
      .cross-list .elementor-widget-container ul,
      .check-list .elementor-widget-container p,
      .cross-list .elementor-widget-container p {
        margin-bottom: 0;
      }

      .elementor-widget-container li:not(.gfield) {
        font-size: 1.8rem;
        line-height: 1.4em;
        list-style-type: initial;
        margin-left: 4rem;
        margin-bottom: 1rem;
      }

      .check-list .elementor-widget-container ul li,
      .cross-list .elementor-widget-container ul li {
        list-style-type: none;
        margin-left: 2.4rem;
        margin-bottom: 0;
      }

      .check-list .elementor-widget-container ul li:before,
      .cross-list .elementor-widget-container ul li:before {
        font-family: fontawesome;
        display: inline-block;
        margin-right: 0.6rem;
        margin-inline-start: -2.45rem;
      }

      .check-list .elementor-widget-container ul li:before {
        content: "\f17b";
        color: #f3f3f3;
        position: relative;
        top: 0.06em;
      }

      .cross-list .elementor-widget-container ul li:before {
        content: "\f191";
      }

      .check-list .elementor-widget-container ol li,
      .cross-list .elementor-widget-container ol li {
        list-style-type: decimal;
        margin-left: 2.2rem;
        margin-bottom: 1rem;
      }

      /*----HERO SECTION STYLE----*/
      #hero:not(.hero-no-background) {
        min-height: 50rem;
      }

      #hero .page-heading {
        margin-bottom: 0.5rem;
      }

      /*------COLUMN WIDTH FOR PAGE CONTENT------*/
      .elementor-section.elementor-section-boxed > .elementor-container {
        max-width: 114rem;
        width: 90%;
      }

      .elementor-inner-section .elementor-container {
        width: 100% !important;
      }

      .elementor-inner-section .elementor-row .elementor-column-wrap {
        padding-left: 0 !important;
      }

      .full-half-half .elementor-container,
      .halftext-halfimage .elementor-container {
        width: 100% !important;
      }

      /*------MAIN BUTTON STYLE------*/
      .elementor-widget-button a.elementor-button,
      .elementor-widget-button .elementor-button {
        line-height: 1em;
        padding: 0.9em 1.6em;
      }

      .elementor-button.elementor-size-lg {
        font-size: 1.8rem;
      }

      h3.elementor-post__title {
        height: 43px;
      }

      /*-----FOOTER GENERAL STYLES-----*/
      .site-footer {
        background-color: #030e13;
        position: fixed;
        bottom: 0;
        width: 100%;
        padding-top: 5rem;
      }

      .site-footer > .wrap {
        padding-bottom: 2rem !important;
      }

      .site-footer a.back-to-top {
        display: none;
      }

      .footer-logo {
        max-width: 15rem;
        margin-bottom: 2rem;
      }

      /*------FOOTER WIDGETS------*/
      .footer-widgets {
        padding-top: 10rem;
        padding-bottom: 4rem;
      }

      .footer-widgets .widget-area {
        margin-bottom: 0;
      }

      .footer-widgets .widget-title {
        font-size: 2rem !important;
        font-weight: 400 !important;
        text-transform: uppercase;
        margin-bottom: 2rem !important;
      }

      .footer-widgets-1 .widget-title {
        text-align: left;
      }

      /*----FOOTER TEXT STYLE----*/
      .site-footer p {
        color: #a8a8a8;
      }

      .site-footer a {
        color: #f3f3f3;
      }

      .site-footer a:hover,
      .site-footer a:active,
      .site-footer a:focus {
        color: #e92326;
      }

      /*----FOOTER SOCIAL ICONS----*/
      .social-wrapper {
        text-align: left;
      }

      .social-icon {
        display: inline-block;
      }

      .site-footer .social-wrapper a {
        display: block;
        width: 4rem;
        height: 4rem;
        margin-right: 0.5rem;
        background: #e92326;
        border-radius: 100%;
        color: #f3f3f3;
        position: relative;
      }

      .site-footer .social-wrapper a:hover,
      .site-footer .social-wrapper a:active,
      .site-footer .social-wrapper a:focus {
        color: #e92326;
        background: #f3f3f3;
      }

      .site-footer .fa-facebook-f {
        font-size: 2.1rem;
        width: 1.2rem;
        left: 1.3rem;
        top: 0.9rem;
      }

      .site-footer .fa-instagram {
        width: 2.2rem;
        left: 0.9rem;
        top: 0.8rem;
      }

      .site-footer .fa-linkedin {
        width: 2.2rem;
        left: 1rem;
        top: 0.8rem;
      }

      .site-footer .fa-youtube {
        width: 2.7rem;
        left: 0.7rem;
        top: 0.8rem;
      }

      .site-footer .fa-vimeo-v {
        width: 2.7rem;
        left: 0.9rem;
        top: 0.9rem;
      }

      /*----FOOTER MENU STYLE----*/
      .menu-junk-drawer-container {
        width: 90%;
      }

      .footer-widgets .menu-item {
        margin-bottom: 0.8rem;
      }

      .footer-widgets .menu-item {
        width: 100%;
      }

      .footer-widgets .menu-item a {
        font-size: 1.6rem;
        line-height: 1.2em;
        text-align: left;
        width: auto;
      }

      .footer-widgets .menu-item a:hover,
      .footer-widgets .menu-item a:active,
      .footer-widgets .menu-item a:focus {
        color: #e92326;
      }

      /*-----FOOTER COPYRIGHT-----*/
      .copyright-wrapper {
        max-width: 100%;
      }

      .copyright-wrapper .p {
        display: inline-block;
        font-size: 1.4rem;
        line-height: 1.2em;
      }
      .copyright {
        width: 80%;
        text-align: left;
        line-height: 1.2em;
      }
      .king-designs-logo-wrapper {
        width: 20%;
        min-width: 13rem;
        display: inline-block;
      }
      .king-designs-logo-wrapper .p {
        text-align: right;
        font-size: 0.9rem;
        font-weight: 900;
        text-transform: uppercase;
        letter-spacing: -0.04em;
        margin-left: auto;
        display: block;
      }
      .king-designs-logo-wrapper a {
        cursor: pointer !important;
        opacity: 0.15;
      }
      .king-designs-logo-wrapper a:hover,
      .king-designs-logo-wrapper a:active,
      .king-designs-logo-wrapper a:focus {
        color: #c1946b;
        opacity: 1;
      }

      /*-----------------------------------------
TABLETS PORTRAIT 895px (iPad) and all widths below this
-----------------------------------------*/
      @media only screen and (max-width: 895px) {
        /*------SITE PADDING------*/
        .site-inner {
          padding: 0;
        }

        /*-----BUTTON STYLES-----*/
        .btn-wrapper,
        .main-btn {
          margin-bottom: 0;
        }

        /*---MOBILE MENU LAYOUT---*/
        #genesis-nav-primary {
          background: #030e13;
        }

        .nav-primary .menu {
          min-height: auto;
          padding: calc((100vh - 96rem) / 2) 0 1em;
          -webkit-box-orient: vertical;
          -webkit-box-direction: normal;
          -webkit-flex-direction: initial;
          -ms-flex-direction: column;
          flex-direction: initial;
          -webkit-box-pack: center;
          -webkit-justify-content: center;
          -ms-flex-pack: center;
          justify-content: center;
          vertical-align: middle;
        }

        /*---MOBILE MENU BUTTON---*/
        header:not(.shrink) button#genesis-mobile-nav-primary {
          padding: 0;
          margin-top: 4.8rem;
        }

        button#genesis-mobile-nav-primary span,
        button#genesis-mobile-nav-primary span::after,
        button#genesis-mobile-nav-primary span::before {
          -webkit-transition: all 0.35s ease-in-out;
          -moz-transition: all 0.35s ease-in-out;
          -o-transition: all 0.35s ease-in-out;
          height: 0.1rem;
        }

        header:not(.shrink)
          button#genesis-mobile-nav-primary.activated
          span::before,
        header:not(.shrink)
          button#genesis-mobile-nav-primary.activated
          span::after {
          background: #f3f3f3 !important;
        }

        button#genesis-mobile-nav-primary {
          width: 4rem;
          height: 2rem;
          margin-top: 3.4rem;
          right: 6vw;
          padding: 0;
          box-shadow: none;
          -webkit-transition: all 0.35s ease-in-out !important;
          -moz-transition: all 0.35s ease-in-out !important;
          -o-transition: all 0.35s ease-in-out !important;
        }

        button#genesis-mobile-nav-primary span {
          width: 4rem;
          top: -1.3rem;
        }

        .menu-toggle.activated span::before,
        .menu-toggle.activated span::after,
        .menu-toggle.activated span {
          -webkit-transition: all 0.35s ease-in-out !important;
          -moz-transition: all 0.35s ease-in-out !important;
          -o-transition: all 0.35s ease-in-out !important;
        }

        .menu-toggle.activated span::before {
          -webkit-transform: rotate(45deg);
          -ms-transform: rotate(45deg);
          transform: rotate(45deg);
        }

        .menu-toggle.activated span::after {
          -webkit-transform: rotate(-225deg);
          -ms-transform: rotate(-225deg);
          transform: rotate(-225deg);
        }

        /*-----MOBILE MENU NAV-----*/
        #menu-main-menu li:not(.mobile-social-heading) {
          padding: 0.8em 0;
        }

        #menu-main-menu
          li:not(.main-menu-cta):not(.mobile-menu-icon):not(.mobile-social-heading)
          a {
          font-size: 2.5rem;
          font-weight: 800;
          color: #f3f3f3;
        }

        /*-----MOBILE MENU CTA-----*/
        #menu-main-menu li.main-menu-cta {
          margin-left: 0;
        }

        #menu-main-menu li.main-menu-cta a {
          background: transparent;
          color: #f3f3f3;
          border: 0.2rem solid #f3f3f3;
          padding: 0.93em 1.56em !important;
        }

        #menu-main-menu li.main-menu-cta a:hover,
        #menu-main-menu li.main-menu-cta a:active,
        #menu-main-menu li.main-menu-cta a:focus {
          opacity: 1;
          background: #40aad5;
          border-color: #40aad5;
          color: #f3f3f3;
        }

        /*----MOBILE MENU SOCIAL HEADING----*/
        .mobile-social-heading {
          display: block;
          margin-top: 15rem;
          margin-bottom: 1rem;
          text-transform: uppercase;
          padding: 0 !important;
        }

        .nav-primary .mobile-social-heading a {
          font-size: 1.7rem;
          font-weight: 800;
        }
        .nav-primary li.mobile-social-heading a:hover,
        .nav-primary li.mobile-social-heading a:active,
        .nav-primary li.mobile-social-heading a:focus {
          color: #f3f3f3 !important;
        }

        /*----MOBILE MENU ICONS----*/
        .nav-primary li.mobile-menu-icon {
          display: inline-block;
          width: auto;
          padding: 0.5rem 0 0 !important;
        }

        .nav-primary li.mobile-menu-icon a {
          font-size: 2.4rem;
          color: #171717;
          background: #f3f3f3;
          height: 4rem;
          width: 4rem;
          border-radius: 100%;
          padding: 0.2em 0.52em;
          margin: 0 0.5rem;
        }

        .nav-primary li.mobile-menu-icon a:hover,
        .nav-primary li.mobile-menu-icon a:active,
        .nav-primary li.mobile-menu-icon a:focus {
          opacity: 1;
          color: #f3f3f3 !important;
          background: #40aad5;
        }

        .mobile-menu-icon i.fab {
          position: relative;
          font-size: 2.1rem;
        }

        .mobile-menu-icon i.fa-facebook-f {
          font-size: 1.9rem;
          top: 0.2rem;
        }

        .mobile-menu-icon i.fa-instagram {
          top: 0.3rem;
          left: -0.2rem;
        }

        .mobile-menu-icon i.fa-linkedin {
          top: 0.3rem;
          left: -0.2rem;
        }

        .mobile-menu-icon i.fa-youtube {
          top: 0.3rem;
          left: -0.4rem;
        }

        .mobile-menu-icon i.fa-vimeo-v {
          top: 0.4rem;
          left: -0.2rem;
        }
      }

      /*-----------------------------------------
MOBILES 767px (iPad) and all widths below this
-----------------------------------------*/
      @media only screen and (max-width: 767px) {
        /*-----FOOTER DRAWER-----*/
        .site-inner {
          margin-bottom: 50rem;
        }

        /*---MOBILE MENU LAYOUT---*/
        .nav-primary .menu {
          min-height: auto;
          padding: calc((100vh - 28rem) / 4) 0 5rem;
        }

        .mobile-social-heading {
          margin-top: 8rem;
        }

        /*--FOOTER GENERAL STYLES--*/
        .footer-logo {
          margin: auto;
          margin-bottom: 2rem;
        }

        /*----FOOTER TEXT STYLE----*/
        .site-footer > .wrap > p {
          max-width: initial;
          text-align: center;
        }

        /*----FOOTER WIDGETS----*/
        .footer-widgets .widget-area {
          margin-bottom: 5rem;
        }

        .footer-widgets .widget-area.footer-widgets-1 {
          margin-bottom: 4rem;
        }

        .footer-widgets .footer-widgets-3 {
          margin-bottom: 0;
        }

        /*------FOOTER MENU------*/
        .footer-widgets .wrap {
          max-width: 400px;
          margin-left: auto;
          margin-right: auto;
        }

        .footer-widgets-2,
        .footer-widgets-3 {
          width: 50%;
          display: inline-block;
        }

        .menu-junk-drawer-container {
          width: 100%;
        }

        .footer-widgets .menu {
          width: 100%;
          max-width: 35rem;
          margin: auto;
        }

        .site-footer .menu-item {
          display: inline-block;
        }

        .footer-widgets .menu-item a {
          text-align: center;
          float: none;
        }

        /*---FOOTER SOCIAL ICONS---*/
        .footer-widgets .widget-title,
        .social-wrapper {
          text-align: center;
          margin: auto;
        }

        i.fab.fa-facebook-f,
        i.fab.fa-pinterest,
        i.fab.fa-instagram {
        }

        i.fab.fa-twitter,
        i.fab.fa-linkedin {
        }

        .site-footer .fa-vimeo-v {
          left: 0.7rem;
        }

        /*----FOOTER COPYRIGHT----*/
        .copyright-wrapper .copyright {
          width: 100%;
          text-align: center;
          margin: auto;
        }

        .king-designs-logo-wrapper {
          width: 100%;
        }

        .king-designs-logo-wrapper .p {
          text-align: center;
        }
      }

      /*-----------------------------------------
MOBILES 641px (iPad) and all widths below this
-----------------------------------------*/

      @media only screen and (max-width: 641px) {
      }

      /*-----------------------------------------
MOBILES 512px (iPhone) and all widths below this
-----------------------------------------*/

      @media only screen and (max-width: 512px) {
        /*----HEADER STYLES----*/
        .site-header:not(.shrink) > .wrap {
          margin-top: 0.5rem;
          margin-bottom: 0.5rem;
        }

        .wp-custom-logo .title-area {
          max-width: 9rem;
        }

        .site-header .title-area a::before {
          height: 3.8rem;
          max-width: 9rem;
          position: absolute;
          opacity: 0;
        }

        header:not(.shrink) button#genesis-mobile-nav-primary {
          margin-top: 2.5rem;
        }

        /*---MOBILE MENU BUTTON---*/
        button#genesis-mobile-nav-primary {
          padding: 0;
          margin-top: 2.5rem;
          width: 3rem;
        }

        button#genesis-mobile-nav-primary span {
          width: 3rem;
        }

        /*----TYPEFACE STYLES----*/
        h1 {
          font-size: 4.5rem;
          line-height: 1em;
        }

        #hero h2,
        .project-hero h2 {
          font-size: 1.8rem;
        }

        h3 {
          font-size: 2.5rem !important;
          line-height: 1em;
        }

        h4 {
          font-size: 1.6rem;
        }

        h5 {
          font-size: 2.2rem;
        }

        .section-heading {
          margin-bottom: 1rem !important;
        }
      }
      .elementor-2349 .elementor-element.elementor-element-f301e1e {
        margin-top: 0px;
      }

      .elementor a {
        color: #171717;
        font-weight: unset;
        text-decoration: unset !important;
      }

      .elementor-element.elementor-element-e70e329.elementor-widget.elementor-widget-text-editor
        a {
        color: #647585 !important;
      }
      .elementor-2485
        .elementor-element.elementor-element-92be47c
        > .elementor-widget-container {
        margin: 0px 0px 0px 0px;
        padding: 0px 0px 0px 0px;
      }

      .elementor-2485
        .elementor-element.elementor-element-711aa75
        > .elementor-widget-container {
        margin: 0px 0px 0px 0px;
        padding: 0px 0px 0px 0px;
      }

      .elementor-2485 .elementor-element.elementor-element-df4f5fe {
        margin-top: 20px;
        margin-bottom: 0px;
        padding: 10px 10px 10px 10px;
      }

      .elementor-2508
        .elementor-element.elementor-element-99fbe6e
        > .elementor-widget-container {
        margin: 0px 0px 0px 0px;
        padding: 0px 0px 0px 0px;
      }

      .elementor-2508 .elementor-element.elementor-element-21ba536 {
        margin-top: 0px;
        margin-bottom: 20px;
        padding: 10px 10px 10px 10px;
      }

      .elementor-2508 .elementor-element.elementor-element-9fc1142 {
        margin-top: 20px;
        margin-bottom: 0px;
        padding: 10px 10px 10px 10px;
      }

      .elementor-2508
        .elementor-element.elementor-element-3cc91fc
        > .elementor-widget-container {
        margin: 0px 0px 0px 0px;
        padding: 0px 0px 0px 0px;
      }

      .elementor-2508
        .elementor-element.elementor-element-236b402
        > .elementor-widget-container {
        margin: 0px 0px 0px 0px;
        padding: 0px 0px 0px 0px;
      }
      .elementor-text-editor.elementor-clearfix a {
        color: #171717;
        font-weight: unset;
        text-decoration: unset !important;
      }
      .elementor-text-editor.elementor-clearfix span {
        color: #171717;
        font-weight: unset;
        text-decoration: unset !important;
      }
    </style>
    <style id="fit-vids-style">
      .fluid-width-video-wrapper {
        width: 100%;
        position: relative;
        padding: 0;
      }
      .fluid-width-video-wrapper iframe,
      .fluid-width-video-wrapper object,
      .fluid-width-video-wrapper embed {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    </style>
  </head>
  <body
    data-rsssl="1"
    class="home page-template page-template-elementor_header_footer page page-id-42 wp-custom-logo header-full-width centered-content genesis-breadcrumbs-hidden genesis-footer-widgets-visible has-fixed-header elementor-default elementor-template-full-width elementor-kit-670 elementor-page elementor-page-42 js e--ua-appleWebkit e--ua-safari e--ua-webkit"
    data-elementor-device-mode="desktop"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 0 0"
      width="0"
      height="0"
      focusable="false"
      role="none"
      style="
        visibility: hidden;
        position: absolute;
        left: -9999px;
        overflow: hidden;
      "
    >
      <defs>
        <filter id="wp-duotone-dark-grayscale">
          <feColorMatrix
            color-interpolation-filters="sRGB"
            type="matrix"
            values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "
          ></feColorMatrix>
          <feComponentTransfer color-interpolation-filters="sRGB">
            <feFuncR type="table" tableValues="0 0.49803921568627"></feFuncR>
            <feFuncG type="table" tableValues="0 0.49803921568627"></feFuncG>
            <feFuncB type="table" tableValues="0 0.49803921568627"></feFuncB>
            <feFuncA type="table" tableValues="1 1"></feFuncA>
          </feComponentTransfer>
          <feComposite in2="SourceGraphic" operator="in"></feComposite>
        </filter>
      </defs></svg
    ><svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 0 0"
      width="0"
      height="0"
      focusable="false"
      role="none"
      style="
        visibility: hidden;
        position: absolute;
        left: -9999px;
        overflow: hidden;
      "
    >
      <defs>
        <filter id="wp-duotone-grayscale">
          <feColorMatrix
            color-interpolation-filters="sRGB"
            type="matrix"
            values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "
          ></feColorMatrix>
          <feComponentTransfer color-interpolation-filters="sRGB">
            <feFuncR type="table" tableValues="0 1"></feFuncR>
            <feFuncG type="table" tableValues="0 1"></feFuncG>
            <feFuncB type="table" tableValues="0 1"></feFuncB>
            <feFuncA type="table" tableValues="1 1"></feFuncA>
          </feComponentTransfer>
          <feComposite in2="SourceGraphic" operator="in"></feComposite>
        </filter>
      </defs></svg
    ><svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 0 0"
      width="0"
      height="0"
      focusable="false"
      role="none"
      style="
        visibility: hidden;
        position: absolute;
        left: -9999px;
        overflow: hidden;
      "
    >
      <defs>
        <filter id="wp-duotone-purple-yellow">
          <feColorMatrix
            color-interpolation-filters="sRGB"
            type="matrix"
            values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "
          ></feColorMatrix>
          <feComponentTransfer color-interpolation-filters="sRGB">
            <feFuncR
              type="table"
              tableValues="0.54901960784314 0.98823529411765"
            ></feFuncR>
            <feFuncG type="table" tableValues="0 1"></feFuncG>
            <feFuncB
              type="table"
              tableValues="0.71764705882353 0.25490196078431"
            ></feFuncB>
            <feFuncA type="table" tableValues="1 1"></feFuncA>
          </feComponentTransfer>
          <feComposite in2="SourceGraphic" operator="in"></feComposite>
        </filter>
      </defs></svg
    ><svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 0 0"
      width="0"
      height="0"
      focusable="false"
      role="none"
      style="
        visibility: hidden;
        position: absolute;
        left: -9999px;
        overflow: hidden;
      "
    >
      <defs>
        <filter id="wp-duotone-blue-red">
          <feColorMatrix
            color-interpolation-filters="sRGB"
            type="matrix"
            values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "
          ></feColorMatrix>
          <feComponentTransfer color-interpolation-filters="sRGB">
            <feFuncR type="table" tableValues="0 1"></feFuncR>
            <feFuncG type="table" tableValues="0 0.27843137254902"></feFuncG>
            <feFuncB
              type="table"
              tableValues="0.5921568627451 0.27843137254902"
            ></feFuncB>
            <feFuncA type="table" tableValues="1 1"></feFuncA>
          </feComponentTransfer>
          <feComposite in2="SourceGraphic" operator="in"></feComposite>
        </filter>
      </defs></svg
    ><svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 0 0"
      width="0"
      height="0"
      focusable="false"
      role="none"
      style="
        visibility: hidden;
        position: absolute;
        left: -9999px;
        overflow: hidden;
      "
    >
      <defs>
        <filter id="wp-duotone-midnight">
          <feColorMatrix
            color-interpolation-filters="sRGB"
            type="matrix"
            values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "
          ></feColorMatrix>
          <feComponentTransfer color-interpolation-filters="sRGB">
            <feFuncR type="table" tableValues="0 0"></feFuncR>
            <feFuncG type="table" tableValues="0 0.64705882352941"></feFuncG>
            <feFuncB type="table" tableValues="0 1"></feFuncB>
            <feFuncA type="table" tableValues="1 1"></feFuncA>
          </feComponentTransfer>
          <feComposite in2="SourceGraphic" operator="in"></feComposite>
        </filter>
      </defs></svg
    ><svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 0 0"
      width="0"
      height="0"
      focusable="false"
      role="none"
      style="
        visibility: hidden;
        position: absolute;
        left: -9999px;
        overflow: hidden;
      "
    >
      <defs>
        <filter id="wp-duotone-magenta-yellow">
          <feColorMatrix
            color-interpolation-filters="sRGB"
            type="matrix"
            values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "
          ></feColorMatrix>
          <feComponentTransfer color-interpolation-filters="sRGB">
            <feFuncR type="table" tableValues="0.78039215686275 1"></feFuncR>
            <feFuncG type="table" tableValues="0 0.94901960784314"></feFuncG>
            <feFuncB
              type="table"
              tableValues="0.35294117647059 0.47058823529412"
            ></feFuncB>
            <feFuncA type="table" tableValues="1 1"></feFuncA>
          </feComponentTransfer>
          <feComposite in2="SourceGraphic" operator="in"></feComposite>
        </filter>
      </defs></svg
    ><svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 0 0"
      width="0"
      height="0"
      focusable="false"
      role="none"
      style="
        visibility: hidden;
        position: absolute;
        left: -9999px;
        overflow: hidden;
      "
    >
      <defs>
        <filter id="wp-duotone-purple-green">
          <feColorMatrix
            color-interpolation-filters="sRGB"
            type="matrix"
            values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "
          ></feColorMatrix>
          <feComponentTransfer color-interpolation-filters="sRGB">
            <feFuncR
              type="table"
              tableValues="0.65098039215686 0.40392156862745"
            ></feFuncR>
            <feFuncG type="table" tableValues="0 1"></feFuncG>
            <feFuncB type="table" tableValues="0.44705882352941 0.4"></feFuncB>
            <feFuncA type="table" tableValues="1 1"></feFuncA>
          </feComponentTransfer>
          <feComposite in2="SourceGraphic" operator="in"></feComposite>
        </filter>
      </defs></svg
    ><svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 0 0"
      width="0"
      height="0"
      focusable="false"
      role="none"
      style="
        visibility: hidden;
        position: absolute;
        left: -9999px;
        overflow: hidden;
      "
    >
      <defs>
        <filter id="wp-duotone-blue-orange">
          <feColorMatrix
            color-interpolation-filters="sRGB"
            type="matrix"
            values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "
          ></feColorMatrix>
          <feComponentTransfer color-interpolation-filters="sRGB">
            <feFuncR type="table" tableValues="0.098039215686275 1"></feFuncR>
            <feFuncG type="table" tableValues="0 0.66274509803922"></feFuncG>
            <feFuncB
              type="table"
              tableValues="0.84705882352941 0.41960784313725"
            ></feFuncB>
            <feFuncA type="table" tableValues="1 1"></feFuncA>
          </feComponentTransfer>
          <feComposite in2="SourceGraphic" operator="in"></feComposite>
        </filter>
      </defs>
    </svg>
    <script type="text/javascript">
     function updateConfig() {
        var eventsFilter = "Microdata,SubscribedButtonClick";
        var eventsFilterList = eventsFilter.split(",");
        fbq.instance.pluginConfig.set("1000529540890267", "openbridge", {
          endpoints: [
            {
              targetDomain: window.location.href,
              endpoint: window.location.href + ".open-bridge",
            },
          ],
          eventsFilter: {
            eventNames: eventsFilterList,
            filteringMode: "blocklist",
          },
        });
        fbq.instance.configLoaded("1000529540890267");
      }

      window.onload = function () {
        var s = document.createElement("script");
        s.setAttribute(
          "src",
          "https://viviantabletennis.com/wp-content/plugins/official-facebook-pixel/core/../js/openbridge_plugin.js"
        );
        s.setAttribute("onload", "updateConfig()");
        document.body.appendChild(s);
      };
    </script>
    <script>
      //<![CDATA[
      (function () {
        var c = document.body.classList;
        c.remove("no-js");
        c.add("js");
      })();

      //]]>
    </script>
    <div class="site-container">
      <ul class="genesis-skip-link">
        <li>
          <a href="#genesis-nav-primary" class="screen-reader-shortcut">
            Skip to primary navigation</a
          >
        </li>
        <li>
          <a href="#genesis-content" class="screen-reader-shortcut">
            Skip to main content</a
          >
        </li>
        <li>
          <a href="#genesis-footer-widgets" class="screen-reader-shortcut">
            Skip to footer</a
          >
        </li>
      </ul>
      <header class="site-header fixed">
        <div class="wrap">
          <div class="title-area">
            <a
              href="https://viviantabletennis.com/"
              class="custom-logo-link"
              rel="home"
              aria-current="page"
              ><img
                width="828"
                height="351"
                src="https://viviantabletennis.com/wp-content/uploads/2022/03/Vivian-Tan-Logo-red-white.png"
                class="custom-logo"
                alt="Vivian table tennis"
                srcset="
                  https://viviantabletennis.com/wp-content/uploads/2022/03/Vivian-Tan-Logo-red-white.png         828w,
                  https://viviantabletennis.com/wp-content/uploads/2022/03/Vivian-Tan-Logo-red-white-300x127.png 300w,
                  https://viviantabletennis.com/wp-content/uploads/2022/03/Vivian-Tan-Logo-red-white-768x326.png 768w
                "
                sizes="(max-width: 828px) 100vw, 828px"
            /></a>
          </div>
          <button
            class="menu-toggle"
            aria-expanded="false"
            aria-pressed="false"
            role="button"
            id="genesis-mobile-nav-primary"
            onclick="toggleNavMenu()"
          >
            Menu<span></span>
          </button>
          <nav
            class="nav-primary genesis-responsive-menu"
            aria-label="Main"
            id="genesis-nav-primary"
            style=""
          >
            <div class="wrap">
              <ul
                id="menu-main-menu"
                class="menu genesis-nav-menu menu-primary js-superfish sf-js-enabled sf-arrows"
                style="touch-action: pan-y"
              >
                <li
                  id="menu-item-1358"
                  class="menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home menu-item-1358"
                >
                  <a href="https://viviantabletennis.com/#about" aria-current="page"
                    ><span>About</span></a
                  >
                </li>
                <li
                  id="menu-item-3304"
                  class="menu-item menu-item-type-post_type menu-item-object-page menu-item-3304"
                >
                  <a href="https://viviantabletennis.com/classes-timetable"
                    ><span>Timetable</span></a
                  >
                </li>
                <li
                  id="menu-item-3176"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-3176"
                >
                  <a href="https://viviantabletennis.com/sydney-holiday-camps"
                    ><span>Holiday Camps</span></a
                  >
                </li>
                 <li
                  id="menu-item-3177"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-3177"
                >
                  <a href="https://viviantabletennis.com/blog"><span>Blogs</span></a>
                </li>
                <li
                  id="menu-item-2003"
                  class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2003"
                >
                  <a href="https://viviantabletennis.com/contact"
                    ><span>Contact</span></a
                  >
                </li>
                <li
                  id="menu-item-1362"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-1362"
                >
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://vtta.ud.io/"
                    ><span>Sign in/Sign up</span></a
                  >
                </li>
                <li
                  id="menu-item-84"
                  class="mobile-social-heading menu-item menu-item-type-custom menu-item-object-custom menu-item-84"
                >
                  <a><span>Follow Us</span></a>
                </li>
                <li
                  id="menu-item-85"
                  class="mobile-menu-icon menu-item menu-item-type-custom menu-item-object-custom menu-item-85"
                >
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.facebook.com/pages/category/Gym-Physical-Fitness-Center/Vivian-Table-Tennis-Academy-123306511684347/"
                    ><span
                      ><i
                        class="fab fa-facebook-f"
                        alt="Vivian table tennis facebook"
                        target="_blank"
                      ></i></span
                  ></a>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </header>
      <div class="site-inner">
        <div
          data-elementor-type="wp-page"
          data-elementor-id="42"
          class="elementor elementor-42"
        >
          <div class="elementor-inner">
            <div class="elementor-section-wrap">
              <section
                class="elementor-section elementor-top-section elementor-element elementor-element-a5243c4 elementor-section-height-full elementor-section-boxed elementor-section-height-default elementor-section-items-middle animated fadeIn"
                data-id="a5243c4"
                data-element_type="section"
                id="hero"
                data-settings='{"background_background":"classic","animation":"fadeIn"}'
              >
                <div class="elementor-background-overlay"></div>
                <div class="elementor-container elementor-column-gap-default">
                  <div class="elementor-row">
                    <div
                      class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1bf4f00"
                      data-id="1bf4f00"
                      data-element_type="column"
                    >
                      <div
                        class="elementor-column-wrap elementor-element-populated"
                      >
                        <div class="elementor-widget-wrap">
                          <div
                            class="elementor-element elementor-element-5f019d1 hero-top-spacer elementor-widget elementor-widget-spacer"
                            data-id="5f019d1"
                            data-element_type="widget"
                            data-widget_type="spacer.default"
                          >
                            <div class="elementor-widget-container">
                              <div class="elementor-spacer">
                                <div class="elementor-spacer-inner"></div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="elementor-element elementor-element-284b139 page-heading elementor-widget elementor-widget-heading animated fadeIn"
                            data-id="284b139"
                            data-element_type="widget"
                            data-settings='{"_animation":"fadeIn","_animation_delay":250}'
                            data-widget_type="heading.default"
                          >
                            <div class="elementor-widget-container">
                              <h1
                                class="elementor-heading-title elementor-size-default"
                              >
                                Raising up tomorrow’s young champions.
                              </h1>
                            </div>
                          </div>
                          <div
                            class="elementor-element elementor-element-d4818c8 page-sub-heading elementor-widget elementor-widget-heading animated fadeIn"
                            data-id="d4818c8"
                            data-element_type="widget"
                            data-settings='{"_animation":"fadeIn","_animation_delay":750}'
                            data-widget_type="heading.default"
                          >
                            <div class="elementor-widget-container">
                              <h2
                                class="elementor-heading-title elementor-size-default"
                              >
                                The Olympic Standard in table tennis coaching
                                for children and students
                              </h2>
                            </div>
                          </div>
    
                          <div
                            class="elementor-element elementor-element-a999ca7 home-cta wire-button elementor-mobile-align-left elementor-widget elementor-widget-button animated fadeIn"
                            data-id="a999ca7"
                            data-element_type="widget"
                            data-settings='{"_animation":"fadeIn","_animation_delay":750}'
                            data-widget_type="button.default"
                          >
                            <div class="elementor-widget-container">
                              <div class="elementor-button-wrapper" style="display:none">
                                <a
                                  href="#elementor-action%3Aaction%3Dlightbox%26settings%3DeyJ0eXBlIjoidmlkZW8iLCJ2aWRlb1R5cGUiOiJ2aW1lbyIsInVybCI6Imh0dHBzOlwvXC9wbGF5ZXIudmltZW8uY29tXC92aWRlb1wvNjU1OTM4NjAxP2g9MTNkNWU1YWQzNyN0PSJ9"
                                  class="elementor-button-link elementor-button elementor-size-lg"
                                  role="button"
                                >
                                  <span
                                    class="elementor-button-content-wrapper"
                                  >
                                    <span class="elementor-button-text"
                                      ><i
                                        class="eicon-play"
                                        aria-hidden="true"
                                      ></i>
                                      Watch video</span
                                    ></span
                                  >
                                </a>
                              </div>
                            </div>
                          </div>
                          <div
                            class="elementor-element elementor-element-4a1a877 elementor-widget elementor-widget-spacer"
                            data-id="4a1a877"
                            data-element_type="widget"
                            data-widget_type="spacer.default"
                          >
                            <div class="elementor-widget-container">
                              <div class="elementor-spacer">
                                <div class="elementor-spacer-inner"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-237fd06"
                      data-id="237fd06"
                      data-element_type="column"
                    >
                      <div
                        class="elementor-column-wrap elementor-element-populated"
                      >
                        <div class="elementor-widget-wrap">
                          <div
                            class="elementor-element elementor-element-20f936f elementor-widget elementor-widget-spacer"
                            data-id="20f936f"
                            data-element_type="widget"
                            data-widget_type="spacer.default"
                          >
                            <div class="elementor-widget-container">
                              <div class="elementor-spacer">
                                <div class="elementor-spacer-inner"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section
                class="elementor-section elementor-top-section elementor-element elementor-element-d91f60a elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                data-id="d91f60a"
                data-element_type="section"
                data-settings='{"background_background":"classic"}'
              >
                <div class="elementor-container elementor-column-gap-default">
                  <div class="elementor-row">
                    <div
                      class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-1855a19 elementor-hidden-tablet elementor-hidden-mobile"
                      data-id="1855a19"
                      data-element_type="column"
                    >
                      <div
                        class="elementor-column-wrap elementor-element-populated"
                      >
                        <div class="elementor-widget-wrap">
                          <div
                            class="elementor-element elementor-element-651f665 feature-image elementor-widget elementor-widget-image animated fadeIn"
                            data-id="651f665"
                            data-element_type="widget"
                            data-settings='{"_animation":"fadeIn"}'
                            data-widget_type="image.default"
                          >
                            <div class="elementor-widget-container">
                              <div class="elementor-image">
                                <img
                                  width="1024"
                                  height="683"
                                  src="https://viviantabletennis.com/wp-content/uploads/2022/03/kids-coaches-jumping-1024x683.jpg"
                                  class="attachment-large size-large"
                                  alt=""
                                  loading="lazy"
                                  srcset="
                                    https://viviantabletennis.com/wp-content/uploads/2022/03/kids-coaches-jumping-1024x683.jpg 1024w,
                                    https://viviantabletennis.com/wp-content/uploads/2022/03/kids-coaches-jumping-300x200.jpg   300w,
                                    https://viviantabletennis.com/wp-content/uploads/2022/03/kids-coaches-jumping-768x512.jpg   768w,
                                    https://viviantabletennis.com/wp-content/uploads/2022/03/kids-coaches-jumping.jpg          1500w
                                  "
                                  sizes="(max-width: 1024px) 100vw, 1024px"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-3515bbe"
                      data-id="3515bbe"
                      data-element_type="column"
                    >
                      <div
                        class="elementor-column-wrap elementor-element-populated"
                      >
                        <div class="elementor-widget-wrap">
                          <div
                            class="elementor-element elementor-element-ce90323 feature-image elementor-widget elementor-widget-image animated fadeIn"
                            data-id="ce90323"
                            data-element_type="widget"
                            data-settings='{"_animation":"fadeIn"}'
                            data-widget_type="image.default"
                          >
                            <div class="elementor-widget-container">
                              <div class="elementor-image">
                                <img
                                  width="1024"
                                  height="683"
                                  src="https://viviantabletennis.com/wp-content/uploads/2022/03/kid-table-tennis-1024x683.jpg"
                                  class="attachment-large size-large"
                                  alt="table tennis coach"
                                  loading="lazy"
                                  srcset="
                                    https://viviantabletennis.com/wp-content/uploads/2022/03/kid-table-tennis-1024x683.jpg 1024w,
                                    https://viviantabletennis.com/wp-content/uploads/2022/03/kid-table-tennis-300x200.jpg   300w,
                                    https://viviantabletennis.com/wp-content/uploads/2022/03/kid-table-tennis-768x512.jpg   768w,
                                    https://viviantabletennis.com/wp-content/uploads/2022/03/kid-table-tennis.jpg          1500w
                                  "
                                  sizes="(max-width: 1024px) 100vw, 1024px"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-b572953"
                      data-id="b572953"
                      data-element_type="column"
                    >
                      <div
                        class="elementor-column-wrap elementor-element-populated"
                      >
                        <div class="elementor-widget-wrap">
                          <div
                            class="elementor-element elementor-element-45cb0ea feature-image elementor-widget elementor-widget-image animated fadeIn"
                            data-id="45cb0ea"
                            data-element_type="widget"
                            data-settings='{"_animation":"fadeIn"}'
                            data-widget_type="image.default"
                          >
                            <div class="elementor-widget-container">
                              <div class="elementor-image">
                                <img
                                  width="1024"
                                  height="683"
                                  src="https://viviantabletennis.com/wp-content/uploads/2022/03/coaches-1024x683.jpg"
                                  class="attachment-large size-large"
                                  alt=""
                                  loading="lazy"
                                  srcset="
                                    https://viviantabletennis.com/wp-content/uploads/2022/03/coaches-1024x683.jpg 1024w,
                                    https://viviantabletennis.com/wp-content/uploads/2022/03/coaches-300x200.jpg   300w,
                                    https://viviantabletennis.com/wp-content/uploads/2022/03/coaches-768x512.jpg   768w,
                                    https://viviantabletennis.com/wp-content/uploads/2022/03/coaches.jpg          1500w
                                  "
                                  sizes="(max-width: 1024px) 100vw, 1024px"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section
                class="elementor-section elementor-top-section elementor-element elementor-element-37017998 doubletext nobackground dark-section elementor-section-full_width elementor-section-height-default elementor-section-height-default"
                data-id="37017998"
                data-element_type="section"
                data-settings='{"background_background":"classic"}'
              >
                <div class="elementor-container elementor-column-gap-default">
                  <div class="elementor-row">
                    <div
                      class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-4993f9ca lefttext"
                      data-id="4993f9ca"
                      data-element_type="column"
                    >
                      <div
                        class="elementor-column-wrap elementor-element-populated"
                      >
                        <div class="elementor-widget-wrap">
                          <div
                            class="elementor-element elementor-element-1b699833 elementor-widget elementor-widget-heading animated fadeIn"
                            data-id="1b699833"
                            data-element_type="widget"
                            data-settings='{"_animation":"fadeIn"}'
                            data-widget_type="heading.default"
                          >
                            <div class="elementor-widget-container">
                              <h3
                                class="elementor-heading-title elementor-size-default"
                              >
                                Looking for a quality table tennis academy and
                                coaches for your child?
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1be95a81 righttext"
                      data-id="1be95a81"
                      data-element_type="column"
                    >
                      <div
                        class="elementor-column-wrap elementor-element-populated"
                      >
                        <div class="elementor-widget-wrap">
                          <div
                            class="elementor-element elementor-element-141c33f7 cross-list elementor-widget elementor-widget-text-editor animated fadeIn"
                            data-id="141c33f7"
                            data-element_type="widget"
                            id="about"
                            data-settings='{"_animation":"fadeIn","_animation_delay":250}'
                            data-widget_type="text-editor.default"
                          >
                            <div class="elementor-widget-container">
                              <div
                                class="elementor-text-editor elementor-clearfix"
                              >
                                <ul>
                                  <li>
                                    Concerned about a friendly coaching
                                    environment?
                                  </li>
                                  <li>
                                    Afraid your child won’t be given the
                                    attention they need?
                                  </li>
                                  <li>
                                    Not sure what level of coaching will be best
                                    for them?
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section
                class="elementor-section elementor-top-section elementor-element elementor-element-625a2f2f doubletext nobackground elementor-section-full_width elementor-section-height-default elementor-section-height-default animated fadeIn"
                data-id="625a2f2f"
                data-element_type="section"
                id="vivian-tan"
                data-settings='{"background_background":"classic","animation":"fadeIn"}'
              >
                <div class="elementor-background-overlay"></div>
                <div class="elementor-container elementor-column-gap-default">
                  <div class="elementor-row">
                    <div
                      class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1fb975 lefttext"
                      data-id="1fb975"
                      data-element_type="column"
                    >
                      <div
                        class="elementor-column-wrap elementor-element-populated"
                      >
                        <div class="elementor-widget-wrap">
                          <div
                            class="elementor-element elementor-element-f3caf18 mask-spacer elementor-widget elementor-widget-spacer"
                            data-id="f3caf18"
                            data-element_type="widget"
                            data-widget_type="spacer.default"
                          >
                            <div class="elementor-widget-container">
                              <div class="elementor-spacer">
                                <div class="elementor-spacer-inner"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-38fb8167 righttext"
                      data-id="38fb8167"
                      data-element_type="column"
                    >
                      <div
                        class="elementor-column-wrap elementor-element-populated"
                      >
                        <div class="elementor-widget-wrap">
                          <div
                            class="elementor-element elementor-element-f684b11 elementor-widget elementor-widget-heading animated fadeIn"
                            data-id="f684b11"
                            data-element_type="widget"
                            data-settings='{"_animation":"fadeIn"}'
                            data-widget_type="heading.default"
                          >
                            <div class="elementor-widget-container">
                              <h3
                                class="elementor-heading-title elementor-size-default"
                              >
                                Come learn table tennis with Olympian, Vivian
                                Tan!
                              </h3>
                            </div>
                          </div>
                          <div
                            class="elementor-element elementor-element-6e36a95e elementor-widget elementor-widget-text-editor animated fadeIn"
                            data-id="6e36a95e"
                            data-element_type="widget"
                            data-settings='{"_animation":"fadeIn","_animation_delay":250}'
                            data-widget_type="text-editor.default"
                          >
                            <div class="elementor-widget-container">
                              <div
                                class="elementor-text-editor elementor-clearfix"
                              >
                                <p>
                                  We believe it should be easy to find a table
                                  tennis academy that is both fun and delivers a
                                  professional standard of coaching.
                                </p>
                                <p>
                                  Vivian’s Table Tennis Academy delivers olympic
                                  standard coaching for the Willoughby area and
                                  Sydney’s North Shore.
                                </p>
                                <p>
                                  We exist to raise up tomorrow’s champions from
                                  ages 5 to 18 years old.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            class="elementor-element elementor-element-10410fec elementor-widget elementor-widget-button animated fadeIn"
                            data-id="10410fec"
                            data-element_type="widget"
                            id="classes"
                            data-settings='{"_animation":"fadeIn","_animation_delay":250}'
                            data-widget_type="button.default"
                          >
                            <div class="elementor-widget-container">
                              <div class="elementor-button-wrapper">
                                <a
                                  href="https://viviantabletennis.com/table-tennis-coach/"
                                  class="elementor-button-link elementor-button elementor-size-sm"
                                  role="button"
                                >
                                  <span
                                    class="elementor-button-content-wrapper"
                                  >
                                    <span class="elementor-button-text"
                                      >Our Table Tennis Coaches</span
                                    >
                                  </span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section
                class="elementor-section elementor-top-section elementor-element elementor-element-323a0e8c doubletext nobackground dark-section elementor-section-full_width elementor-reverse-mobile elementor-section-height-default elementor-section-height-default animated fadeIn"
                data-id="323a0e8c"
                data-element_type="section"
                id="term-classes"
                data-settings='{"background_background":"classic","animation":"fadeIn"}'
              >
                <div class="elementor-container elementor-column-gap-default">
                  <div class="elementor-row">
                    <div
                      class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-12da14a9 lefttext"
                      data-id="12da14a9"
                      data-element_type="column"
                    >
                      <div
                        class="elementor-column-wrap elementor-element-populated"
                      >
                        <div class="elementor-widget-wrap">
                          <div
                            class="elementor-element elementor-element-138b4de5 elementor-widget elementor-widget-heading animated fadeIn"
                            data-id="138b4de5"
                            data-element_type="widget"
                            data-settings='{"_animation":"fadeIn"}'
                            data-widget_type="heading.default"
                          >
                            <div class="elementor-widget-container">
                              <h3
                                class="elementor-heading-title elementor-size-default"
                              >
                                Term classes
                              </h3>
                            </div>
                          </div>
                          <div
                            class="elementor-element elementor-element-6a2cf63d elementor-widget elementor-widget-text-editor animated fadeIn"
                            data-id="6a2cf63d"
                            data-element_type="widget"
                            data-settings='{"_animation":"fadeIn","_animation_delay":250}'
                            data-widget_type="text-editor.default"
                          >
                            <div class="elementor-widget-container">
                              <div
                                class="elementor-text-editor elementor-clearfix"
                              >
                                <p>
                                  We have multiple classes each week that run at
                                  set times during the school term. Book a free
                                  trial lesson for your child today and
                                  experience an environment that encourages
                                  growth and learning.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            class="elementor-element elementor-element-7be40bc0 elementor-widget elementor-widget-button animated fadeIn"
                            data-id="7be40bc0"
                            data-element_type="widget"
                            data-settings='{"_animation":"fadeIn","_animation_delay":250}'
                            data-widget_type="button.default"
                          >
                            <div class="elementor-widget-container">
                              <div class="elementor-button-wrapper">
                                <a
                                  href="https://viviantabletennis.com/classes-timetable/"
                                  class="elementor-button-link elementor-button elementor-size-sm"
                                  role="button"
                                >
                                  <span
                                    class="elementor-button-content-wrapper"
                                  >
                                    <span class="elementor-button-text"
                                      >Class timetable</span
                                    >
                                  </span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-3cd3081c righttext"
                      data-id="3cd3081c"
                      data-element_type="column"
                    >
                      <div
                        class="elementor-column-wrap elementor-element-populated"
                      >
                        <div class="elementor-widget-wrap">
                          <div
                            class="elementor-element elementor-element-42f9f87 mask-spacer elementor-widget elementor-widget-spacer"
                            data-id="42f9f87"
                            data-element_type="widget"
                            data-widget_type="spacer.default"
                          >
                            <div class="elementor-widget-container">
                              <div class="elementor-spacer">
                                <div class="elementor-spacer-inner"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section
                class="elementor-section elementor-top-section elementor-element elementor-element-f5ae8bc doubletext nobackground dark-section elementor-section-full_width elementor-reverse-mobile elementor-section-height-default elementor-section-height-default animated fadeIn"
                data-id="f5ae8bc"
                data-element_type="section"
                id="school-holiday-camp"
                data-settings='{"background_background":"classic","animation":"fadeIn"}'
              >
                <div class="elementor-container elementor-column-gap-default">
                  <div class="elementor-row">
                    <div
                      class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-753c442 lefttext"
                      data-id="753c442"
                      data-element_type="column"
                    >
                      <div
                        class="elementor-column-wrap elementor-element-populated"
                      >
                        <div class="elementor-widget-wrap">
                          <div
                            class="elementor-element elementor-element-c299a88 elementor-invisible elementor-widget elementor-widget-heading"
                            data-id="c299a88"
                            data-element_type="widget"
                            data-settings='{"_animation":"fadeIn"}'
                            data-widget_type="heading.default"
                          >
                            <div class="elementor-widget-container">
                              <h3
                                class="elementor-heading-title elementor-size-default"
                              >
                                School holiday camp
                              </h3>
                            </div>
                          </div>
                          <div
                            class="elementor-element elementor-element-8875a04 elementor-invisible elementor-widget elementor-widget-text-editor"
                            data-id="8875a04"
                            data-element_type="widget"
                            data-settings='{"_animation":"fadeIn","_animation_delay":250}'
                            data-widget_type="text-editor.default"
                          >
                            <div class="elementor-widget-container">
                              <div
                                class="elementor-text-editor elementor-clearfix"
                              >
                                <p>
                                  Every school holiday, we create opportunities
                                  for kids to have fun and connect with each
                                  other while learning a skill that they can
                                  keep for life. Spaces fill up fast so book
                                  your child in today.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            class="elementor-element elementor-element-6b1553c elementor-invisible elementor-widget elementor-widget-button"
                            data-id="6b1553c"
                            data-element_type="widget"
                            data-settings='{"_animation":"fadeIn","_animation_delay":250}'
                            data-widget_type="button.default"
                          >
                            <div class="elementor-widget-container">
                              <div class="elementor-button-wrapper">
                                <a
                                  href="https://viviantabletennis.com/sydney-holiday-camps"
                                  class="elementor-button-link elementor-button elementor-size-sm"
                                  role="button"
                                >
                                  <span
                                    class="elementor-button-content-wrapper"
                                  >
                                    <span class="elementor-button-text"
                                      >Register now</span
                                    >
                                  </span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-4b09075 righttext"
                      data-id="4b09075"
                      data-element_type="column"
                    >
                      <div
                        class="elementor-column-wrap elementor-element-populated"
                      >
                        <div class="elementor-widget-wrap">
                          <div
                            class="elementor-element elementor-element-2ec26a1 mask-spacer elementor-widget elementor-widget-spacer"
                            data-id="2ec26a1"
                            data-element_type="widget"
                            data-widget_type="spacer.default"
                          >
                            <div class="elementor-widget-container">
                              <div class="elementor-spacer">
                                <div class="elementor-spacer-inner"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section
                class="elementor-section elementor-top-section elementor-element elementor-element-b7e2fdc doubletext nobackground dark-section elementor-section-full_width elementor-reverse-mobile elementor-section-height-default elementor-section-height-default elementor-invisible"
                data-id="b7e2fdc"
                data-element_type="section"
                id="corporate-events"
                data-settings='{"background_background":"classic","animation":"fadeIn"}'
              >
                <div class="elementor-container elementor-column-gap-default">
                  <div class="elementor-row">
                    <div
                      class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-0d9c239 lefttext"
                      data-id="0d9c239"
                      data-element_type="column"
                    >
                      <div
                        class="elementor-column-wrap elementor-element-populated"
                      >
                        <div class="elementor-widget-wrap">
                          <div
                            class="elementor-element elementor-element-6e2759a elementor-invisible elementor-widget elementor-widget-heading"
                            data-id="6e2759a"
                            data-element_type="widget"
                            data-settings='{"_animation":"fadeIn"}'
                            data-widget_type="heading.default"
                          >
                            <div class="elementor-widget-container">
                              <h3
                                class="elementor-heading-title elementor-size-default"
                              >
                                Corporate events
                              </h3>
                            </div>
                          </div>
                          <div
                            class="elementor-element elementor-element-5a44a47 elementor-invisible elementor-widget elementor-widget-text-editor"
                            data-id="5a44a47"
                            data-element_type="widget"
                            data-settings='{"_animation":"fadeIn","_animation_delay":250}'
                            data-widget_type="text-editor.default"
                          >
                            <div class="elementor-widget-container">
                              <div
                                class="elementor-text-editor elementor-clearfix"
                              >
                                <p>
                                  Looking for a fun event for your company? We
                                  host many friendly competitions and events for
                                  corporate groups throughout the year. Enquire
                                  today about what we can organise for your
                                  group event.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            class="elementor-element elementor-element-afe1393 elementor-invisible elementor-widget elementor-widget-button"
                            data-id="afe1393"
                            data-element_type="widget"
                            id="testimonials"
                            data-settings='{"_animation":"fadeIn","_animation_delay":250}'
                            data-widget_type="button.default"
                          >
                            <div class="elementor-widget-container">
                              <div class="elementor-button-wrapper">
                                <a
                                  href="https://viviantabletennis.com/book-an-event/"
                                  class="elementor-button-link elementor-button elementor-size-sm"
                                  role="button"
                                >
                                  <span
                                    class="elementor-button-content-wrapper"
                                  >
                                    <span class="elementor-button-text"
                                      >Enquire today</span
                                    >
                                  </span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-a1995ea righttext"
                      data-id="a1995ea"
                      data-element_type="column"
                    >
                      <div
                        class="elementor-column-wrap elementor-element-populated"
                      >
                        <div class="elementor-widget-wrap">
                          <div
                            class="elementor-element elementor-element-2b60ce4 mask-spacer elementor-widget elementor-widget-spacer"
                            data-id="2b60ce4"
                            data-element_type="widget"
                            data-widget_type="spacer.default"
                          >
                            <div class="elementor-widget-container">
                              <div class="elementor-spacer">
                                <div class="elementor-spacer-inner"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section
                class="elementor-section elementor-top-section elementor-element elementor-element-3f56b8bf elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                data-id="3f56b8bf"
                data-element_type="section"
                id="reviews"
                data-settings='{"background_background":"classic"}'
              >
                <div class="elementor-container elementor-column-gap-default">
                  <div class="elementor-row">
                    <div
                      class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-547c3d6b"
                      data-id="547c3d6b"
                      data-element_type="column"
                    >
                      <div
                        class="elementor-column-wrap elementor-element-populated"
                      >
                        <div class="elementor-widget-wrap e-swiper-container">
                          <div
                            class="elementor-element elementor-element-18b9e0ee elementor-testimonial--skin-default elementor-testimonial--layout-image_inline elementor-testimonial--align-center elementor-pagination-type-bullets elementor-invisible elementor-widget elementor-widget-testimonial-carousel e-widget-swiper"
                            data-id="18b9e0ee"
                            data-element_type="widget"
                            data-settings='{"_animation":"fadeIn","pagination":"bullets","speed":500,"loop":"yes","space_between":{"unit":"px","size":10,"sizes":[]},"space_between_tablet":{"unit":"px","size":10,"sizes":[]},"space_between_mobile":{"unit":"px","size":10,"sizes":[]}}'
                            data-widget_type="testimonial-carousel.default"
                          >
                            <div class="elementor-widget-container">
                              <div class="elementor-swiper">
                                <div
                                  class="elementor-main-swiper swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-ios"
                                >
                                  <div
                                    class="swiper-wrapper"
                                    style="
                                      transition-duration: 0ms;
                                      transform: translate3d(-1130px, 0px, 0px);
                                    "
                                  >
                                    <div
                                      class="swiper-slide swiper-slide-duplicate swiper-slide-prev"
                                      data-swiper-slide-index="2"
                                      style="width: 1120px; margin-right: 10px"
                                    >
                                      <div class="elementor-testimonial">
                                        <div
                                          class="elementor-testimonial__content"
                                        >
                                          <div
                                            class="elementor-testimonial__text"
                                          >
                                            <h4>
                                              "My girl loved their NSW Sport and
                                              Recreation Camp...''
                                            </h4>
                                            <p>
                                              My 9-year-old girl joined their
                                              recreation camp and she enjoyed it
                                              so much and made so many friends
                                            </p>
                                            <p>
                                              also this is one of the best TT
                                              training academies in the region
                                              that organise tennis
                                            </p>
                                            <p>
                                              camps in Sydney for both girls and
                                              boys
                                            </p>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-testimonial__footer"
                                        >
                                          <cite
                                            class="elementor-testimonial__cite"
                                            ><span
                                              class="elementor-testimonial__name"
                                            >
                                              Melissa</span
                                            ><span
                                              class="elementor-testimonial__title"
                                            >
                                              Mom of Vivian Tan fan</span
                                            ></cite
                                          >
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      class="swiper-slide swiper-slide-active"
                                      data-swiper-slide-index="0"
                                      style="width: 1120px; margin-right: 10px"
                                    >
                                      <div class="elementor-testimonial">
                                        <div
                                          class="elementor-testimonial__content"
                                        >
                                          <div
                                            class="elementor-testimonial__text"
                                          >
                                            <h4>
                                              “My older boy is now competing at
                                              a state level...”
                                            </h4>
                                            <p>
                                              As my kids say, “You learn
                                              different skills, tricks and
                                              strategies to be competitive and
                                              have fun.” You get to meet a great
                                              bunch of people, it's very
                                              inclusive, and the monthly
                                              tournaments are great for both
                                              compeitive and non-competitive
                                              people.
                                            </p>
                                            <p>
                                              My older boy is now competing at a
                                              state level and representing his
                                              high school.
                                            </p>
                                            <p>
                                              We recommend you give Vivian Table
                                              Tennis Academy a try.”
                                            </p>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-testimonial__footer"
                                        >
                                          <cite
                                            class="elementor-testimonial__cite"
                                            ><span
                                              class="elementor-testimonial__name"
                                              >Adam</span
                                            ><span
                                              class="elementor-testimonial__title"
                                              >Dad of two boys // Students at
                                              VTTA</span
                                            ></cite
                                          >
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      class="swiper-slide swiper-slide-next"
                                      data-swiper-slide-index="1"
                                      style="width: 1120px; margin-right: 10px"
                                    >
                                      <div class="elementor-testimonial">
                                        <div
                                          class="elementor-testimonial__content"
                                        >
                                          <div
                                            class="elementor-testimonial__text"
                                          >
                                            <h4>
                                              "Best TT Academy for Kids &amp;
                                              Youths..."
                                            </h4>
                                            <p>
                                              Best table tennis training
                                              provider near me. Both of my
                                              children are going there for table
                                              tennis training.
                                            </p>
                                            <p>
                                              The coach is very professional and
                                              skilful. This place has a friendly
                                              environment for the students.
                                            </p>
                                            <p>
                                              Vivian table tennis academy is
                                              highly recommended by me
                                            </p>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-testimonial__footer"
                                        >
                                          <cite
                                            class="elementor-testimonial__cite"
                                            ><span
                                              class="elementor-testimonial__name"
                                              >Joseph</span
                                            ><span
                                              class="elementor-testimonial__title"
                                              >Dad of Two VTTians</span
                                            ></cite
                                          >
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      class="swiper-slide swiper-slide-duplicate-prev"
                                      data-swiper-slide-index="2"
                                      style="width: 1120px; margin-right: 10px"
                                    >
                                      <div class="elementor-testimonial">
                                        <div
                                          class="elementor-testimonial__content"
                                        >
                                          <div
                                            class="elementor-testimonial__text"
                                          >
                                            <h4>
                                              "My girl loved their NSW Sport and
                                              Recreation Camp...''
                                            </h4>
                                            <p>
                                              My 9-year-old girl joined their
                                              recreation camp and she enjoyed it
                                              so much and made so many friends
                                            </p>
                                            <p>
                                              also this is one of the best TT
                                              training academies in the region
                                              that organise tennis
                                            </p>
                                            <p>
                                              camps in Sydney for both girls and
                                              boys
                                            </p>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-testimonial__footer"
                                        >
                                          <cite
                                            class="elementor-testimonial__cite"
                                            ><span
                                              class="elementor-testimonial__name"
                                            >
                                              Melissa</span
                                            ><span
                                              class="elementor-testimonial__title"
                                            >
                                              Mom of Vivian Tan fan</span
                                            ></cite
                                          >
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      class="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-active"
                                      data-swiper-slide-index="0"
                                      style="width: 1120px; margin-right: 10px"
                                    >
                                      <div class="elementor-testimonial">
                                        <div
                                          class="elementor-testimonial__content"
                                        >
                                          <div
                                            class="elementor-testimonial__text"
                                          >
                                            <h4>
                                              “My older boy is now competing at
                                              a state level...”
                                            </h4>
                                            <p>
                                              As my kids say, “You learn
                                              different skills, tricks and
                                              strategies to be competitive and
                                              have fun.” You get to meet a great
                                              bunch of people, it's very
                                              inclusive, and the monthly
                                              tournaments are great for both
                                              compeitive and non-competitive
                                              people.
                                            </p>
                                            <p>
                                              My older boy is now competing at a
                                              state level and representing his
                                              high school.
                                            </p>
                                            <p>
                                              We recommend you give Vivian Table
                                              Tennis Academy a try.”
                                            </p>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-testimonial__footer"
                                        >
                                          <cite
                                            class="elementor-testimonial__cite"
                                            ><span
                                              class="elementor-testimonial__name"
                                              >Adam</span
                                            ><span
                                              class="elementor-testimonial__title"
                                              >Dad of two boys // Students at
                                              VTTA</span
                                            ></cite
                                          >
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets"
                                  >
                                    <span
                                      class="swiper-pagination-bullet swiper-pagination-bullet-active"
                                      tabindex="0"
                                      role="button"
                                      aria-label="Go to slide 1"
                                    ></span
                                    ><span
                                      class="swiper-pagination-bullet"
                                      tabindex="0"
                                      role="button"
                                      aria-label="Go to slide 2"
                                    ></span
                                    ><span
                                      class="swiper-pagination-bullet"
                                      tabindex="0"
                                      role="button"
                                      aria-label="Go to slide 3"
                                    ></span>
                                  </div>
                                  <span
                                    class="swiper-notification"
                                    aria-live="assertive"
                                    aria-atomic="true"
                                  ></span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section
                class="elementor-section elementor-top-section elementor-element elementor-element-511fbda doubletext nobackground dark-section elementor-section-full_width elementor-section-height-default elementor-section-height-default elementor-invisible"
                data-id="511fbda"
                data-element_type="section"
                id="why-choose-us"
                data-settings='{"background_background":"classic","animation":"fadeIn"}'
              >
                <div class="elementor-background-overlay"></div>
                <div class="elementor-container elementor-column-gap-default">
                  <div class="elementor-row">
                    <div
                      class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-d472aeb lefttext"
                      data-id="d472aeb"
                      data-element_type="column"
                    >
                      <div
                        class="elementor-column-wrap elementor-element-populated"
                      >
                        <div class="elementor-widget-wrap">
                          <div
                            class="elementor-element elementor-element-c490828 mask-spacer elementor-widget elementor-widget-spacer"
                            data-id="c490828"
                            data-element_type="widget"
                            data-widget_type="spacer.default"
                          >
                            <div class="elementor-widget-container">
                              <div class="elementor-spacer">
                                <div class="elementor-spacer-inner"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-e56ce3e righttext"
                      data-id="e56ce3e"
                      data-element_type="column"
                    >
                      <div
                        class="elementor-column-wrap elementor-element-populated"
                      >
                        <div class="elementor-widget-wrap">
                          <div
                            class="elementor-element elementor-element-7b6912b elementor-invisible elementor-widget elementor-widget-heading"
                            data-id="7b6912b"
                            data-element_type="widget"
                            data-settings='{"_animation":"fadeIn"}'
                            data-widget_type="heading.default"
                          >
                            <div class="elementor-widget-container">
                              <h3
                                class="elementor-heading-title elementor-size-default"
                              >
                                Why should you choose Vivian’s Table Tennis
                                Academy for your child?
                              </h3>
                            </div>
                          </div>
                          <div
                            class="elementor-element elementor-element-9129a81 check-list elementor-invisible elementor-widget elementor-widget-text-editor"
                            data-id="9129a81"
                            data-element_type="widget"
                            data-settings='{"_animation":"fadeIn","_animation_delay":250}'
                            data-widget_type="text-editor.default"
                          >
                            <div class="elementor-widget-container">
                              <div
                                class="elementor-text-editor elementor-clearfix"
                              >
                                <ul>
                                  <li>12 classes every week</li>
                                  <li>
                                    Beginner, intermediate, and advanced levels
                                  </li>
                                  <li>
                                    14 years of Olympic-standard coaching
                                    experience
                                  </li>
                                  <li>
                                    Guaranteed coach-to-student ratio of 1:3
                                  </li>
                                  <li>Fun and friendly coaches and players</li>
                                  <li>
                                    Structured learning environment including
                                    assessments
                                  </li>
                                  <li>
                                    We focus on the transformation of the
                                    students in their self-confidence, skills
                                    ability, and their increasing achievements
                                  </li>
                                  <li>
                                    Represent the state competitively in the
                                    State Team
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div
                            class="elementor-element elementor-element-c287ebc elementor-widget elementor-widget-spacer"
                            data-id="c287ebc"
                            data-element_type="widget"
                            id="how-it-works"
                            data-widget_type="spacer.default"
                          >
                            <div class="elementor-widget-container">
                              <div class="elementor-spacer">
                                <div class="elementor-spacer-inner"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section
                class="elementor-section elementor-top-section elementor-element elementor-element-735f803a plan-section elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                data-id="735f803a"
                data-element_type="section"
              >
                <div class="elementor-container elementor-column-gap-default">
                  <div class="elementor-row">
                    <div
                      class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-e42e2b8"
                      data-id="e42e2b8"
                      data-element_type="column"
                    >
                      <div
                        class="elementor-column-wrap elementor-element-populated"
                      >
                        <div class="elementor-widget-wrap">
                          <div
                            class="elementor-element elementor-element-3332f239 elementor-invisible elementor-widget elementor-widget-heading"
                            data-id="3332f239"
                            data-element_type="widget"
                            data-settings='{"_animation":"fadeIn"}'
                            data-widget_type="heading.default"
                          >
                            <div class="elementor-widget-container">
                              <h3
                                class="elementor-heading-title elementor-size-default"
                              >
                                Want to join the Vivian Table Tennis Academy
                                family?
                              </h3>
                            </div>
                          </div>
                          <section
                            class="elementor-section elementor-inner-section elementor-element elementor-element-697eaeda plan elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                            data-id="697eaeda"
                            data-element_type="section"
                          >
                            <div
                              class="elementor-container elementor-column-gap-default"
                            >
                              <div class="elementor-row">
                                <div
                                  class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-1cdd4946 elementor-invisible"
                                  data-id="1cdd4946"
                                  data-element_type="column"
                                  data-settings='{"animation":"fadeIn","animation_delay":250}'
                                >
                                  <div
                                    class="elementor-column-wrap elementor-element-populated"
                                  >
                                    <div class="elementor-widget-wrap">
                                      <div
                                        class="elementor-element elementor-element-40fb498 step step1 elementor-cta--skin-classic elementor-animated-content elementor-widget elementor-widget-call-to-action"
                                        data-id="40fb498"
                                        data-element_type="widget"
                                        data-widget_type="call-to-action.default"
                                      >
                                        <div class="elementor-widget-container">
                                          <div class="elementor-cta">
                                            <div
                                              class="elementor-cta__bg-wrapper"
                                            >
                                              <div
                                                class="elementor-cta__bg elementor-bg"
                                                style="
                                                  background-image: url(https://viviantabletennis.com/wp-content/uploads/2022/03/table-tennis-step1.png);
                                                "
                                              ></div>
                                              <div
                                                class="elementor-cta__bg-overlay"
                                              ></div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-70dcc874 elementor-invisible"
                                  data-id="70dcc874"
                                  data-element_type="column"
                                  data-settings='{"animation":"fadeIn","animation_delay":350}'
                                >
                                  <div
                                    class="elementor-column-wrap elementor-element-populated"
                                  >
                                    <div class="elementor-widget-wrap">
                                      <div
                                        class="elementor-element elementor-element-9c4c451 step step2 elementor-cta--skin-classic elementor-animated-content elementor-widget elementor-widget-call-to-action"
                                        data-id="9c4c451"
                                        data-element_type="widget"
                                        data-widget_type="call-to-action.default"
                                      >
                                        <div class="elementor-widget-container">
                                          <div class="elementor-cta">
                                            <div
                                              class="elementor-cta__bg-wrapper"
                                            >
                                              <div
                                                class="elementor-cta__bg elementor-bg"
                                                style="
                                                  background-image: url(https://viviantabletennis.com/wp-content/uploads/2022/03/table-tennis-step2.png);
                                                "
                                              ></div>
                                              <div
                                                class="elementor-cta__bg-overlay"
                                              ></div>
                                            </div>
                                            <div class="elementor-cta__content">
                                              <h5
                                                class="elementor-cta__title elementor-cta__content-item elementor-content-item"
                                              >
                                                Register for term
                                              </h5>
                                              <div
                                                class="elementor-cta__description elementor-cta__content-item elementor-content-item"
                                              >
                                                Find yourself smiling during
                                                your trial? Join the rest of our
                                                Vivian family for term.
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-68f433c3 elementor-invisible"
                                  data-id="68f433c3"
                                  data-element_type="column"
                                  data-settings='{"animation":"fadeIn","animation_delay":450}'
                                >
                                  <div
                                    class="elementor-column-wrap elementor-element-populated"
                                  >
                                    <div class="elementor-widget-wrap">
                                      <div
                                        class="elementor-element elementor-element-102f1b4 step step3 elementor-cta--skin-classic elementor-animated-content elementor-widget elementor-widget-call-to-action"
                                        data-id="102f1b4"
                                        data-element_type="widget"
                                        data-widget_type="call-to-action.default"
                                      >
                                        <div class="elementor-widget-container">
                                          <div class="elementor-cta">
                                            <div
                                              class="elementor-cta__bg-wrapper"
                                            >
                                              <div
                                                class="elementor-cta__bg elementor-bg"
                                                style="
                                                  background-image: url(https://viviantabletennis.com/wp-content/uploads/2022/03/table-tennis-step3.png);
                                                "
                                              ></div>
                                              <div
                                                class="elementor-cta__bg-overlay"
                                              ></div>
                                            </div>
                                            <div class="elementor-cta__content">
                                              <h5
                                                class="elementor-cta__title elementor-cta__content-item elementor-content-item"
                                              >
                                                Reach potential
                                              </h5>
                                              <div
                                                class="elementor-cta__description elementor-cta__content-item elementor-content-item"
                                              >
                                                Track your child's progress
                                                during the term and watch their
                                                abilities come alive.
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      <footer class="site-footer">
        <div class="wrap">
          <div class="footer-widgets" id="genesis-footer-widgets">
            <h2 class="genesis-sidebar-title screen-reader-text">Footer</h2>
            <div class="wrap">
              <div class="widget-area footer-widgets-1 footer-widget-area">
                <section
                  id="custom_html-3"
                  class="widget_text widget widget_custom_html"
                >
                  <div class="widget_text widget-wrap">
                    <div class="textwidget custom-html-widget">
                      <img
                        src="https://viviantabletennis.com/wp-content/uploads/2022/03/Vivian-Tan-Logo-red-white.png"
                        class="footer-logo"
                      />
                      <div class="social-wrapper">
                        <div class="social-icon facebook">
                          <a
                            href="https://www.facebook.com/pages/category/Gym-Physical-Fitness-Center/Vivian-Table-Tennis-Academy-123306511684347/"
                            target="_blank"
                            rel="noopener"
                          >
                            <i
                              class="fab fa-facebook-f"
                              alt="Vivian table tennis facebook"
                            ></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div class="widget-area footer-widgets-2 footer-widget-area">
                <section id="nav_menu-6" class="widget widget_nav_menu">
                  <div class="widget-wrap">
                    <div class="menu-footer-menu-container">
                      <ul id="menu-footer-menu" class="menu">
                        <li
                          id="menu-item-1451"
                          class="menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home menu-item-1451"
                        >
                          <a
                            href="https://viviantabletennis.com/#about"
                            aria-current="page"
                            >About Us</a
                          >
                        </li>
                        <li
                          id="menu-item-2324"
                          class="menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home menu-item-2324"
                        >
                          <a
                            href="https://viviantabletennis.com/#classes"
                            aria-current="page"
                            >Coaching</a
                          >
                        </li>
                        <li
                          id="menu-item-2005"
                          class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2005"
                        >
                          <a href="https://viviantabletennis.com/contact/">Contact</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </section>
              </div>
              <div class="widget-area footer-widgets-3 footer-widget-area">
                <section id="nav_menu-4" class="widget widget_nav_menu">
                  <div class="widget-wrap">
                    <div class="menu-junk-drawer-container">
                      <ul id="menu-junk-drawer" class="menu">
                        <li
                          id="menu-item-1448"
                          class="menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home menu-item-1448"
                        >
                          <a
                            href="https://viviantabletennis.com/#how-it-works"
                            aria-current="page"
                            >How it works</a
                          >
                        </li>
                        <li
                          id="menu-item-1450"
                          class="menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home menu-item-1450"
                        >
                          <a
                            href="https://viviantabletennis.com/#testimonials"
                            aria-current="page"
                            >Reviews</a
                          >
                        </li>
                        <li
                          id="menu-item-3303"
                          class="menu-item menu-item-type-post_type menu-item-object-page menu-item-3303"
                        >
                          <a href="https://viviantabletennis.com/table-tennis-coach/"
                            >Our Coaches</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </section>
              </div>
              <div class="widget-area footer-widgets-4 footer-widget-area">
                <section id="nav_menu-7" class="widget widget_nav_menu">
                  <div class="widget-wrap">
                    <div class="menu-footer-3-container">
                      <ul id="menu-footer-3" class="menu">
                        <li
                          id="menu-item-3186"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-3186"
                        >
                          <a href="https://viviantabletennis.com/lower-north-shore/"
                            >Table Tennis Lower North Shore</a
                          >
                        </li>
                        <li
                          id="menu-item-3187"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-3187"
                        >
                          <a href="https://viviantabletennis.com/upper-north-shore/"
                            >Table Tennis North Shore</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
          <div class="copyright-wrapper">
            <div class="p copyright">
              ©
              <script>
                document.write(new Date().getFullYear());
              </script>
              2022 Vivian Table Tennis. All rights reserved
            </div>
            <div class="king-designs-logo-wrapper">
              <div class="p">
                <a href="http://www.kingdesigns.digital" target="_blank"
                  >By King Designs</a
                >
              </div>
            </div>
          </div>
          <a href="#top" class="back-to-top"></a>
        </div>
      </footer>
    </div>
    <!-- Google Tag Manager (noscript) -->
    <noscript
      ><iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-P9KW2RJ"
        height="0"
        width="0"
        style="display: none; visibility: hidden"
      ></iframe
    ></noscript>
    <!-- End Google Tag Manager (noscript) -->
    <!-- Meta Pixel Event Code -->
    <script type="text/javascript">
      document.addEventListener(
        "wpcf7mailsent",
        function (event) {
          if ("fb_pxl_code" in event.detail.apiResponse) {
            eval(event.detail.apiResponse.fb_pxl_code);
          }
        },
        false
      );
    </script>
    <!-- End Meta Pixel Event Code -->
    <div id="fb-pxl-ajax-code"></div>
    <link
      rel="stylesheet"
      id="e-animations-css"
      href="https://viviantabletennis.com/wp-content/plugins/elementor/assets/lib/animations/animations.min.css?ver=3.8.0"
      type="text/css"
      media="all"
    />
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-includes/js/hoverIntent.min.js?ver=1.10.2"
      id="hoverIntent-js"
    ></script>
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-content/themes/genesis/lib/js/menu/superfish.min.js?ver=1.7.10"
      id="superfish-js"
    ></script>
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-content/themes/genesis/lib/js/menu/superfish.args.min.js?ver=3.4.0"
      id="superfish-args-js"
    ></script>
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-content/themes/genesis/lib/js/skip-links.min.js?ver=3.4.0"
      id="skip-links-js"
    ></script>
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-content/themes/business-pro-theme/assets/scripts/min/jquery.fitvids.min.js?ver=1.1.0"
      id="fitvids-js"
    ></script>
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-content/themes/business-pro-theme/assets/scripts/min/business-pro.min.js?ver=1.1.0"
      id="business-pro-theme-js"
    ></script>
    <script type="text/javascript" id="business-menu-js-extra">
      /* <![CDATA[ */
      var genesis_responsive_menu = {
        mainMenu: "Menu",
        subMenu: "Menu",
        menuIconClass: null,
        subMenuIconClass: null,
        menuClasses: { combine: [".nav-primary"] },
      };
      /* ]]> */
    </script>
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-content/themes/business-pro-theme/assets/scripts/min/menus.min.js?ver=1.1.0"
      id="business-menu-js"
    ></script>
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-includes/js/imagesloaded.min.js?ver=4.1.4"
      id="imagesloaded-js"
    ></script>
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-content/plugins/elementor-pro/assets/js/webpack-pro.runtime.min.js?ver=3.7.7"
      id="elementor-pro-webpack-runtime-js"
    ></script>
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-content/plugins/elementor/assets/js/webpack.runtime.min.js?ver=3.8.0"
      id="elementor-webpack-runtime-js"
    ></script>
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-content/plugins/elementor/assets/js/frontend-modules.min.js?ver=3.8.0"
      id="elementor-frontend-modules-js"
    ></script>
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-includes/js/dist/vendor/regenerator-runtime.min.js?ver=0.13.9"
      id="regenerator-runtime-js"
    ></script>
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-includes/js/dist/vendor/wp-polyfill.min.js?ver=3.15.0"
      id="wp-polyfill-js"
    ></script>
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-includes/js/dist/hooks.min.js?ver=c6d64f2cb8f5c6bb49caca37f8828ce3"
      id="wp-hooks-js"
    ></script>
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-includes/js/dist/i18n.min.js?ver=ebee46757c6a411e38fd079a7ac71d94"
      id="wp-i18n-js"
    ></script>
    <script type="text/javascript" id="wp-i18n-js-after">
      wp.i18n.setLocaleData({ "text direction\u0004ltr": ["ltr"] });
    </script>
    <script type="text/javascript" id="elementor-pro-frontend-js-before">
      var ElementorProFrontendConfig = {
        ajaxurl:
          "https:\/\/www.viviantabletennis.com.au\/wp-admin\/admin-ajax.php",
        nonce: "ebba2f6bbe",
        urls: {
          assets:
            "https:\/\/www.viviantabletennis.com.au\/wp-content\/plugins\/elementor-pro\/assets\/",
          rest: "https:\/\/www.viviantabletennis.com.au\/wp-json\/",
        },
        shareButtonsNetworks: {
          facebook: { title: "Facebook", has_counter: true },
          twitter: { title: "Twitter" },
          linkedin: { title: "LinkedIn", has_counter: true },
          pinterest: { title: "Pinterest", has_counter: true },
          reddit: { title: "Reddit", has_counter: true },
          vk: { title: "VK", has_counter: true },
          odnoklassniki: { title: "OK", has_counter: true },
          tumblr: { title: "Tumblr" },
          digg: { title: "Digg" },
          skype: { title: "Skype" },
          stumbleupon: { title: "StumbleUpon", has_counter: true },
          mix: { title: "Mix" },
          telegram: { title: "Telegram" },
          pocket: { title: "Pocket", has_counter: true },
          xing: { title: "XING", has_counter: true },
          whatsapp: { title: "WhatsApp" },
          email: { title: "Email" },
          print: { title: "Print" },
        },
        facebook_sdk: { lang: "en_US", app_id: "" },
        lottie: {
          defaultAnimationUrl:
            "https:\/\/www.viviantabletennis.com.au\/wp-content\/plugins\/elementor-pro\/modules\/lottie\/assets\/animations\/default.json",
        },
      };
    </script>
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-content/plugins/elementor-pro/assets/js/frontend.min.js?ver=3.7.7"
      id="elementor-pro-frontend-js"
    ></script>
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-content/plugins/elementor/assets/lib/waypoints/waypoints.min.js?ver=4.0.2"
      id="elementor-waypoints-js"
    ></script>
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-includes/js/jquery/ui/core.min.js?ver=1.13.1"
      id="jquery-ui-core-js"
    ></script>
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-content/plugins/elementor/assets/lib/swiper/swiper.min.js?ver=5.3.6"
      id="swiper-js"
    ></script>
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-content/plugins/elementor/assets/lib/share-link/share-link.min.js?ver=3.8.0"
      id="share-link-js"
    ></script>
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-content/plugins/elementor/assets/lib/dialog/dialog.min.js?ver=4.9.0"
      id="elementor-dialog-js"
    ></script>
    <script type="text/javascript" id="elementor-frontend-js-before">
      var elementorFrontendConfig = {
        environmentMode: {
          edit: false,
          wpPreview: false,
          isScriptDebug: false,
        },
        i18n: {
          shareOnFacebook: "Share on Facebook",
          shareOnTwitter: "Share on Twitter",
          pinIt: "Pin it",
          download: "Download",
          downloadImage: "Download image",
          fullscreen: "Fullscreen",
          zoom: "Zoom",
          share: "Share",
          playVideo: "Play Video",
          previous: "Previous",
          next: "Next",
          close: "Close",
        },
        is_rtl: false,
        breakpoints: { xs: 0, sm: 480, md: 768, lg: 1025, xl: 1440, xxl: 1600 },
        responsive: {
          breakpoints: {
            mobile: {
              label: "Mobile",
              value: 767,
              default_value: 767,
              direction: "max",
              is_enabled: true,
            },
            mobile_extra: {
              label: "Mobile Extra",
              value: 880,
              default_value: 880,
              direction: "max",
              is_enabled: false,
            },
            tablet: {
              label: "Tablet",
              value: 1024,
              default_value: 1024,
              direction: "max",
              is_enabled: true,
            },
            tablet_extra: {
              label: "Tablet Extra",
              value: 1200,
              default_value: 1200,
              direction: "max",
              is_enabled: false,
            },
            laptop: {
              label: "Laptop",
              value: 1366,
              default_value: 1366,
              direction: "max",
              is_enabled: false,
            },
            widescreen: {
              label: "Widescreen",
              value: 2400,
              default_value: 2400,
              direction: "min",
              is_enabled: false,
            },
          },
        },
        version: "3.8.0",
        is_static: false,
        experimentalFeatures: {
          e_import_export: true,
          e_hidden_wordpress_widgets: true,
          theme_builder_v2: true,
          "landing-pages": true,
          "elements-color-picker": true,
          "favorite-widgets": true,
          "admin-top-bar": true,
          "page-transitions": true,
          notes: true,
          "form-submissions": true,
          e_scroll_snap: true,
        },
        urls: {
          assets:
            "https:\/\/www.viviantabletennis.com.au\/wp-content\/plugins\/elementor\/assets\/",
        },
        settings: { page: [], editorPreferences: [] },
        kit: {
          active_breakpoints: ["viewport_mobile", "viewport_tablet"],
          global_image_lightbox: "yes",
          lightbox_enable_counter: "yes",
          lightbox_enable_fullscreen: "yes",
          lightbox_enable_zoom: "yes",
          lightbox_enable_share: "yes",
          lightbox_title_src: "title",
          lightbox_description_src: "description",
        },
        post: {
          id: 42,
          title:
            "Vivian%20Tan%20Table%20Tennis%20Academy%20%7C%20TT%20Coaching%20%7CHoliday%20Camps%20Sydney",
          excerpt: "",
          featuredImage: false,
        },
      };
    </script>
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-content/plugins/elementor/assets/js/frontend.min.js?ver=3.8.0"
      id="elementor-frontend-js"
    ></script>
    <span id="elementor-device-mode" class="elementor-screen-only"></span>
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-content/plugins/elementor-pro/assets/js/preloaded-elements-handlers.min.js?ver=3.7.7"
      id="pro-preloaded-elements-handlers-js"
    ></script>
    <svg style="display: none" class="e-font-icon-svg-symbols"></svg>
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-content/plugins/elementor/assets/js/preloaded-modules.min.js?ver=3.8.0"
      id="preloaded-modules-js"
    ></script>
    <svg style="display: none" class="e-font-icon-svg-symbols"></svg>
    <script
      type="text/javascript"
      src="https://viviantabletennis.com/wp-content/plugins/elementor-pro/assets/lib/sticky/jquery.sticky.min.js?ver=3.7.7"
      id="e-sticky-js"
    ></script>

    <script
      src="https://viviantabletennis.com/wp-content/plugins/official-facebook-pixel/core/../js/openbridge_plugin.js"
      onload="updateConfig()"
    ></script>
  </body>
</html>
`;
